// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graphiql-container,
.graphiql-container button,
.graphiql-container input {
  color: #141823;
  font-family: system, -apple-system, 'San Francisco', '.SFNSDisplay-Regular',
    'Segoe UI', Segoe, 'Segoe WP', 'Helvetica Neue', helvetica, 'Lucida Grande',
    arial, sans-serif;
  font-size: 14px;
}

.graphiql-container {
  display: flex;
  flex-direction: row;
  height: 100%;
  margin: 0;
  overflow: hidden;
  width: 100%;
}

.graphiql-container .editorWrap {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-x: hidden;
}

.graphiql-container .title {
  font-size: 18px;
}

.graphiql-container .title em {
  font-family: georgia;
  font-size: 19px;
}

.graphiql-container .topBarWrap {
  display: flex;
  flex-direction: row;
}

.graphiql-container .topBar {
  align-items: center;
  background: linear-gradient(#f7f7f7, #e2e2e2);
  border-bottom: 1px solid #d0d0d0;
  cursor: default;
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 34px;
  overflow-y: visible;
  padding: 7px 14px 6px;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.graphiql-container .toolbar {
  overflow-x: visible;
  display: flex;
}

.graphiql-container .docExplorerShow,
.graphiql-container .historyShow {
  background: linear-gradient(#f7f7f7, #e2e2e2);
  border-radius: 0;
  border-bottom: 1px solid #d0d0d0;
  border-right: none;
  border-top: none;
  color: #3b5998;
  cursor: pointer;
  font-size: 14px;
  margin: 0;
  outline: 0;
  padding: 2px 20px 0 18px;
}

.graphiql-container .docExplorerShow {
  border-left: 1px solid rgba(0, 0, 0, 0.2);
}

.graphiql-container .historyShow {
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  border-left: 0;
}

.graphiql-container .docExplorerShow:before {
  border-left: 2px solid #3b5998;
  border-top: 2px solid #3b5998;
  content: '';
  display: inline-block;
  height: 9px;
  margin: 0 3px -1px 0;
  position: relative;
  transform: rotate(-45deg);
  width: 9px;
}

.graphiql-container .editorBar {
  display: flex;
  flex-direction: row;
  flex: 1;
}

.graphiql-container .queryWrap {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.graphiql-container .resultWrap {
  border-left: solid 1px #e0e0e0;
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
}

.graphiql-container .docExplorerWrap,
.graphiql-container .historyPaneWrap {
  background: white;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 3;
}

.graphiql-container .historyPaneWrap {
  min-width: 230px;
  z-index: 5;
}

.graphiql-container .docExplorerResizer {
  cursor: col-resize;
  height: 100%;
  left: -5px;
  position: absolute;
  top: 0;
  width: 10px;
  z-index: 10;
}

.graphiql-container .docExplorerHide {
  cursor: pointer;
  font-size: 18px;
  margin: -7px -8px -6px 0;
  padding: 18px 16px 15px 12px;
}

.graphiql-container div .query-editor {
  flex: 1;
  position: relative;
}

.graphiql-container .variable-editor {
  display: flex;
  flex-direction: column;
  height: 30px;
  position: relative;
}

.graphiql-container .variable-editor-title {
  background: #eeeeee;
  border-bottom: 1px solid #d6d6d6;
  border-top: 1px solid #e0e0e0;
  color: #777;
  font-variant: small-caps;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 14px;
  padding: 6px 0 8px 43px;
  text-transform: lowercase;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.graphiql-container .codemirrorWrap {
  flex: 1;
  height: 100%;
  position: relative;
}

.graphiql-container .result-window {
  flex: 1;
  height: 100%;
  position: relative;
}

.graphiql-container .footer {
  background: #f6f7f8;
  border-left: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
  margin-left: 12px;
  position: relative;
}

.graphiql-container .footer:before {
  background: #eeeeee;
  bottom: 0;
  content: ' ';
  left: -13px;
  position: absolute;
  top: -1px;
  width: 12px;
}

/* No \`.graphiql-container\` here so themes can overwrite */

.result-window .CodeMirror {
  background: #f6f7f8;
}

.graphiql-container .result-window .CodeMirror-gutters {
  background-color: #eeeeee;
  border-color: #e0e0e0;
  cursor: col-resize;
}

.graphiql-container .result-window .CodeMirror-foldgutter,
.graphiql-container .result-window .CodeMirror-foldgutter-open:after,
.graphiql-container .result-window .CodeMirror-foldgutter-folded:after {
  padding-left: 3px;
}

.graphiql-container .toolbar-button {
  background: #fdfdfd;
  background: linear-gradient(#f9f9f9, #ececec);
  border-radius: 3px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.2),
    0 1px 0 rgba(255, 255, 255, 0.7), inset 0 1px #fff;
  color: #555;
  cursor: pointer;
  display: inline-block;
  margin: 0 5px;
  padding: 3px 11px 3px;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}

.graphiql-container .toolbar-button span i {
  margin-left: 5px;
}

.graphiql-container .toolbar-button:active {
  background: linear-gradient(#ececec, #d5d5d5);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.7),
    inset 0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 1px 1px 1px rgba(0, 0, 0, 0.12),
    inset 0 0 5px rgba(0, 0, 0, 0.1);
}

.graphiql-container .toolbar-button.error {
  background: linear-gradient(#fdf3f3, #e6d6d7);
  color: #b00;
}

.graphiql-container .toolbar-button.primary {
  background: #f9c548;
  border: 1px solid #d5ae52;
  box-shadow: none;
  color: #475569;
  font-weight: 500;
}

.graphiql-container .toolbar-button-group {
  margin: 0 5px;
  white-space: nowrap;
}

.graphiql-container .toolbar-button-group > * {
  margin: 0;
}

.graphiql-container .toolbar-button-group > *:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.graphiql-container .toolbar-button-group > *:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  margin-left: -1px;
}

.graphiql-container .execute-button-wrap {
  height: 34px;
  margin: 0 14px 0 28px;
  position: relative;
}

.graphiql-container .execute-button {
  background: linear-gradient(#fdfdfd, #d2d3d6);
  border-radius: 17px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  box-shadow: 0 1px 0 #fff;
  cursor: pointer;
  fill: #444;
  height: 34px;
  margin: 0;
  padding: 0;
  width: 34px;
}

.graphiql-container .execute-button svg {
  pointer-events: none;
}

.graphiql-container .execute-button:active {
  background: linear-gradient(#e6e6e6, #c3c3c3);
  box-shadow: 0 1px 0 #fff, inset 0 0 2px rgba(0, 0, 0, 0.2),
    inset 0 0 6px rgba(0, 0, 0, 0.1);
}

.graphiql-container .execute-button:focus {
  outline: 0;
}

.graphiql-container .toolbar-menu,
.graphiql-container .toolbar-select {
  position: relative;
}

.graphiql-container .execute-options,
.graphiql-container .toolbar-menu-items,
.graphiql-container .toolbar-select-options {
  background: #fff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.25);
  margin: 0;
  padding: 6px 0;
  position: absolute;
  z-index: 100;
}

.graphiql-container .execute-options {
  min-width: 100px;
  top: 37px;
  left: -1px;
}

.graphiql-container .toolbar-menu-items {
  left: 1px;
  margin-top: -1px;
  min-width: 110%;
  top: 100%;
  visibility: hidden;
}

.graphiql-container .toolbar-menu-items.open {
  visibility: visible;
}

.graphiql-container .toolbar-select-options {
  left: 0;
  min-width: 100%;
  top: -5px;
  visibility: hidden;
}

.graphiql-container .toolbar-select-options.open {
  visibility: visible;
}

.graphiql-container .execute-options > li,
.graphiql-container .toolbar-menu-items > li,
.graphiql-container .toolbar-select-options > li {
  cursor: pointer;
  display: block;
  margin: none;
  max-width: 300px;
  overflow: hidden;
  padding: 2px 20px 4px 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.graphiql-container .execute-options > li.selected,
.graphiql-container .toolbar-menu-items > li.hover,
.graphiql-container .toolbar-menu-items > li:active,
.graphiql-container .toolbar-menu-items > li:hover,
.graphiql-container .toolbar-select-options > li.hover,
.graphiql-container .toolbar-select-options > li:active,
.graphiql-container .toolbar-select-options > li:hover,
.graphiql-container .history-contents > li:hover,
.graphiql-container .history-contents > li:active {
  background: #e10098;
  color: #fff;
}

.graphiql-container .toolbar-select-options > li > svg {
  display: inline;
  fill: #666;
  margin: 0 -6px 0 6px;
  pointer-events: none;
  vertical-align: middle;
}

.graphiql-container .toolbar-select-options > li.hover > svg,
.graphiql-container .toolbar-select-options > li:active > svg,
.graphiql-container .toolbar-select-options > li:hover > svg {
  fill: #fff;
}

.graphiql-container .CodeMirror-scroll {
  overflow-scrolling: touch;
}

.graphiql-container .CodeMirror {
  color: #141823;
  font-family: 'Consolas', 'Inconsolata', 'Droid Sans Mono', 'Monaco', monospace;
  font-size: 13px;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.graphiql-container .CodeMirror-lines {
  padding: 20px 0;
}

.CodeMirror-hint-information .content {
  box-orient: vertical;
  color: #141823;
  display: flex;
  font-family: system, -apple-system, 'San Francisco', '.SFNSDisplay-Regular',
    'Segoe UI', Segoe, 'Segoe WP', 'Helvetica Neue', helvetica, 'Lucida Grande',
    arial, sans-serif;
  font-size: 13px;
  line-clamp: 3;
  line-height: 16px;
  max-height: 48px;
  overflow: hidden;
  text-overflow: -o-ellipsis-lastline;
}

.CodeMirror-hint-information .content p:first-child {
  margin-top: 0;
}

.CodeMirror-hint-information .content p:last-child {
  margin-bottom: 0;
}

.CodeMirror-hint-information .infoType {
  color: #ca9800;
  cursor: pointer;
  display: inline;
  margin-right: 0.5em;
}

.autoInsertedLeaf.cm-property {
  animation-duration: 6s;
  animation-name: insertionFade;
  border-bottom: 2px solid rgba(255, 255, 255, 0);
  border-radius: 2px;
  margin: -2px -4px -1px;
  padding: 2px 4px 1px;
}

@keyframes insertionFade {
  from,
  to {
    background: rgba(255, 255, 255, 0);
    border-color: rgba(255, 255, 255, 0);
  }

  15%,
  85% {
    background: #fbffc9;
    border-color: #f0f3c0;
  }
}

div.CodeMirror-lint-tooltip {
  background-color: white;
  border-radius: 2px;
  border: 0;
  color: #141823;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
  font-family: system, -apple-system, 'San Francisco', '.SFNSDisplay-Regular',
    'Segoe UI', Segoe, 'Segoe WP', 'Helvetica Neue', helvetica, 'Lucida Grande',
    arial, sans-serif;
  font-size: 13px;
  line-height: 16px;
  max-width: 430px;
  opacity: 0;
  padding: 8px 10px;
  transition: opacity 0.15s;
  white-space: pre-wrap;
}

div.CodeMirror-lint-tooltip > * {
  padding-left: 23px;
}

div.CodeMirror-lint-tooltip > * + * {
  margin-top: 12px;
}

/* COLORS */

.graphiql-container .CodeMirror-foldmarker {
  border-radius: 4px;
  background: #08f;
  background: linear-gradient(#43a8ff, #0f83e8);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2), inset 0 0 0 1px rgba(0, 0, 0, 0.1);
  color: white;
  font-family: arial;
  font-size: 12px;
  line-height: 0;
  margin: 0 3px;
  padding: 0px 4px 1px;
  text-shadow: 0 -1px rgba(0, 0, 0, 0.1);
}

.graphiql-container div.CodeMirror span.CodeMirror-matchingbracket {
  color: #555;
  text-decoration: underline;
}

.graphiql-container div.CodeMirror span.CodeMirror-nonmatchingbracket {
  color: #f00;
}

/* Comment */

.cm-comment {
  color: #999;
}

/* Punctuation */

.cm-punctuation {
  color: #555;
}

/* Keyword */

.cm-keyword {
  color: #b11a04;
}

/* OperationName, FragmentName */

.cm-def {
  color: #d2054e;
}

/* FieldName */

.cm-property {
  color: #1f61a0;
}

/* FieldAlias */

.cm-qualifier {
  color: #1c92a9;
}

/* ArgumentName and ObjectFieldName */

.cm-attribute {
  color: #8b2bb9;
}

/* Number */

.cm-number {
  color: #2882f9;
}

/* String */

.cm-string {
  color: #d64292;
}

/* Boolean */

.cm-builtin {
  color: #d47509;
}

/* EnumValue */

.cm-string-2 {
  color: #0b7fc7;
}

/* Variable */

.cm-variable {
  color: #397d13;
}

/* Directive */

.cm-meta {
  color: #b33086;
}

/* Type */

.cm-atom {
  color: #ca9800;
}

/* Hasura Analyse modal css */

.wd25 {
  width: 25%;
  display: inline-block;
}

.wd75 {
  width: 75%;
  display: inline-block;
}

.wd40 {
  width: 40%;
  display: inline-block;
}

.wd60 {
  width: 60%;
  display: inline-block;
}

.modalWrapper {
  position: absolute;
  top: 40px;
  left: 40px;
  right: 40px;
  bottom: 40px;
  border: 1px solid rgb(204, 204, 204);
  background: rgb(255, 255, 255);
  border-radius: 4px;
  outline: none;
}

.myOverlayClass {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 100;
}

.modalHeader {
  background-color: #43495a;
  border-bottom: 1px solid #ccc;
  padding: 10px 20px;
  position: relative;
  color: #ffc627;
}

.modalTitle {
  font-size: 18px;
  font-weight: 500;
}

.modalClose {
  position: absolute;
  right: 10px;
  top: 10px;
}

.modalClose button {
  cursor: pointer;
  border-radius: 5px;
  border: 0;
  background-color: transparent;
  font-size: 16px;
  font-weight: 700;
  color: #ccc;
  padding: 0px;
  height: auto;
}

.modalClose button:hover {
  border: 0;
  background-color: transparent;
  color: #fff;
}

.modalClose button:focus {
  outline: none;
}

.modalBody {
  display: flex;
  height: calc(100% - 46px);
}

.topLevelNodesWrapper {
  border-right: 1px solid #ccc;
  height: 100%;
}

.textCenter {
  text-align: center;
}

.topLevelNodesWrapper .title {
  padding: 15px 20px;
  background-color: #fff3d5;
  margin-bottom: 20px;
  color: #767e93;
  font-weight: 600;
  font-size: 16px;
}

.analysisWrapper {
  height: 100%;
  position: relative;
  width: 100%;
}

.topLevelNodesWrapper ul {
  -webkit-padding-start: 0px;
          padding-inline-start: 0px;
  margin-top: 0;
  margin-bottom: 0;
}

.borderRight {
  border-right: 1px solid #ccc;
}

.topLevelNodesWrapper ul li {
  list-style-type: none;
  padding: 10px 0;
  padding-left: 20px;
  cursor: pointer;
}

.topLevelNodesWrapper ul li i {
  margin-right: 5px;
  font-size: 12px;
}

.topLevelNodesWrapper ul li.active {
  color: #fd9540;
}

.topLevelNodesWrapper ul li:hover {
  color: #e2701a;
}

.plansWrapper {
  height: 50%;
  position: relative;
  padding: 0px 20px;
}

.plansTitle {
  padding: 10px 0px;
  color: #767e93;
  font-weight: 600;
}

/* BASICS */

.CodeMirror {
  /* Set height, width, borders, and global font properties here */
  color: black;
  font-family: monospace;
  height: 300px;
}

/* PADDING */

.CodeMirror-lines {
  padding: 4px 0; /* Vertical padding around content */
}

.CodeMirror pre {
  padding: 0 4px; /* Horizontal padding of content */
}

.CodeMirror-scrollbar-filler,
.CodeMirror-gutter-filler {
  background-color: white; /* The little square between H and V scrollbars */
}

/* GUTTER */

.CodeMirror-gutters {
  border-right: 1px solid #ddd;
  background-color: #f7f7f7;
  white-space: nowrap;
}

.CodeMirror-linenumbers {
}

.CodeMirror-linenumber {
  color: #999;
  min-width: 20px;
  padding: 0 3px 0 5px;
  text-align: right;
  white-space: nowrap;
}

.CodeMirror-guttermarker {
  color: black;
}

.CodeMirror-guttermarker-subtle {
  color: #999;
}

/* CURSOR */

.CodeMirror .CodeMirror-cursor {
  border-left: 1px solid black;
}

/* Shown when moving in bi-directional text */

.CodeMirror div.CodeMirror-secondarycursor {
  border-left: 1px solid silver;
}

.CodeMirror.cm-fat-cursor div.CodeMirror-cursor {
  background: #7e7;
  border: 0;
  width: auto;
}

.CodeMirror.cm-fat-cursor div.CodeMirror-cursors {
  z-index: 1;
}

.cm-animate-fat-cursor {
  animation: blink 1.06s steps(1) infinite;
  border: 0;
  width: auto;
}

@keyframes blink {
  0% {
    background: #7e7;
  }
  50% {
    background: none;
  }
  100% {
    background: #7e7;
  }
}

/* Can style cursor different in overwrite (non-insert) mode */

div.CodeMirror-overwrite div.CodeMirror-cursor {
}

.cm-tab {
  display: inline-block;
  text-decoration: inherit;
}

.CodeMirror-ruler {
  border-left: 1px solid #ccc;
  position: absolute;
}

/* DEFAULT THEME */

.cm-s-default .cm-keyword {
  color: #708;
}

.cm-s-default .cm-atom {
  color: #219;
}

.cm-s-default .cm-number {
  color: #164;
}

.cm-s-default .cm-def {
  color: #00f;
}

.cm-s-default .cm-variable,
.cm-s-default .cm-punctuation,
.cm-s-default .cm-property,
.cm-s-default .cm-operator {
}

.cm-s-default .cm-variable-2 {
  color: #05a;
}

.cm-s-default .cm-variable-3 {
  color: #085;
}

.cm-s-default .cm-comment {
  color: #a50;
}

.cm-s-default .cm-string {
  color: #a11;
}

.cm-s-default .cm-string-2 {
  color: #f50;
}

.cm-s-default .cm-meta {
  color: #555;
}

.cm-s-default .cm-qualifier {
  color: #555;
}

.cm-s-default .cm-builtin {
  color: #30a;
}

.cm-s-default .cm-bracket {
  color: #997;
}

.cm-s-default .cm-tag {
  color: #170;
}

.cm-s-default .cm-attribute {
  color: #00c;
}

.cm-s-default .cm-header {
  color: blue;
}

.cm-s-default .cm-quote {
  color: #090;
}

.cm-s-default .cm-hr {
  color: #999;
}

.cm-s-default .cm-link {
  color: #00c;
}

.cm-negative {
  color: #d44;
}

.cm-positive {
  color: #292;
}

.cm-header,
.cm-strong {
  font-weight: bold;
}

.cm-em {
  font-style: italic;
}

.cm-link {
  text-decoration: underline;
}

.cm-strikethrough {
  text-decoration: line-through;
}

.cm-s-default .cm-error {
  color: #f00;
}

.cm-invalidchar {
  color: #f00;
}

.CodeMirror-composing {
  border-bottom: 2px solid;
}

/* Default styles for common addons */

div.CodeMirror span.CodeMirror-matchingbracket {
  color: #0f0;
}

div.CodeMirror span.CodeMirror-nonmatchingbracket {
  color: #f22;
}

.CodeMirror-matchingtag {
  background: rgba(255, 150, 0, 0.3);
}

.CodeMirror-activeline-background {
  background: #e8f2ff;
}

/* STOP */

/* The rest of this file contains styles related to the mechanics of
   the editor. You probably shouldn't touch them. */

.CodeMirror {
  background: white;
  overflow: hidden;
  position: relative;
}

.CodeMirror-scroll {
  height: 100%;
  /* 30px is the magic margin used to hide the element's real scrollbars */
  /* See overflow: hidden in .CodeMirror */
  margin-bottom: -30px;
  margin-right: -30px;
  outline: none; /* Prevent dragging from highlighting the element */
  overflow: scroll !important; /* Things will break if this is overridden */
  padding-bottom: 30px;
  position: relative;
}

.CodeMirror-sizer {
  border-right: 30px solid transparent;
  position: relative;
}

/* The fake, visible scrollbars. Used to force redraw during scrolling
   before actual scrolling happens, thus preventing shaking and
   flickering artifacts. */

.CodeMirror-vscrollbar,
.CodeMirror-hscrollbar,
.CodeMirror-scrollbar-filler,
.CodeMirror-gutter-filler {
  display: none;
  position: absolute;
  z-index: 6;
}

.CodeMirror-vscrollbar {
  overflow-x: hidden;
  overflow-y: scroll;
  right: 0;
  top: 0;
}

.CodeMirror-hscrollbar {
  bottom: 0;
  left: 0;
  overflow-x: scroll;
  overflow-y: hidden;
}

.CodeMirror-scrollbar-filler {
  right: 0;
  bottom: 0;
}

.CodeMirror-gutter-filler {
  left: 0;
  bottom: 0;
}

.CodeMirror-gutters {
  min-height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
}

.CodeMirror-gutter {
  display: inline-block;
  height: 100%;
  margin-bottom: -30px;
  vertical-align: top;
  white-space: normal;
  /* Hack to make IE7 behave */
  *zoom: 1;
  *display: inline;
}

.CodeMirror-gutter-wrapper {
  background: none !important;
  border: none !important;
  position: absolute;
  z-index: 4;
}

.CodeMirror-gutter-background {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 4;
}

.CodeMirror-gutter-elt {
  cursor: default;
  position: absolute;
  z-index: 4;
}

.CodeMirror-gutter-wrapper {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.CodeMirror-lines {
  cursor: text;
  min-height: 1px; /* prevents collapsing before first draw */
}

.CodeMirror pre {
  -webkit-tap-highlight-color: transparent;
  /* Reset some styles that the rest of the page might have set */
  background: transparent;
  border-radius: 0;
  border-width: 0;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-variant-ligatures: none;
  line-height: inherit;
  margin: 0;
  overflow: visible;
  position: relative;
  white-space: pre;
  word-wrap: normal;
  z-index: 2;
}

.CodeMirror-wrap pre {
  word-wrap: break-word;
  white-space: pre-wrap;
  word-break: normal;
}

.CodeMirror-linebackground {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 0;
}

.CodeMirror-linewidget {
  overflow: auto;
  position: relative;
  z-index: 2;
}

.CodeMirror-widget {
}

.CodeMirror-code {
  outline: none;
}

/* Force content-box sizing for the elements where we expect it */

.CodeMirror-scroll,
.CodeMirror-sizer,
.CodeMirror-gutter,
.CodeMirror-gutters,
.CodeMirror-linenumber {
  box-sizing: content-box;
}

.CodeMirror-measure {
  height: 0;
  overflow: hidden;
  position: absolute;
  visibility: hidden;
  width: 100%;
}

.CodeMirror-cursor {
  position: absolute;
}

.CodeMirror-measure pre {
  position: static;
}

div.CodeMirror-cursors {
  position: relative;
  visibility: hidden;
  z-index: 3;
}

div.CodeMirror-dragcursors {
  visibility: visible;
}

.CodeMirror-focused div.CodeMirror-cursors {
  visibility: visible;
}

.CodeMirror-selected {
  background: #d9d9d9;
}

.CodeMirror-focused .CodeMirror-selected {
  background: #d7d4f0;
}

.CodeMirror-crosshair {
  cursor: crosshair;
}

.CodeMirror-line::-moz-selection, .CodeMirror-line > span::-moz-selection, .CodeMirror-line > span > span::-moz-selection {
  background: #d7d4f0;
}

.CodeMirror-line::selection,
.CodeMirror-line > span::selection,
.CodeMirror-line > span > span::selection {
  background: #d7d4f0;
}

.CodeMirror-line::-moz-selection,
.CodeMirror-line > span::-moz-selection,
.CodeMirror-line > span > span::-moz-selection {
  background: #d7d4f0;
}

.cm-searching {
  background: #ffa;
  background: rgba(255, 255, 0, 0.4);
}

/* IE7 hack to prevent it from returning funny offsetTops on the spans */

.CodeMirror span {
  *vertical-align: text-bottom;
}

/* Used to force a border model for a node */

.cm-force-border {
  padding-right: 0.1px;
}

@media print {
  /* Hide the cursor when printing */
  .CodeMirror div.CodeMirror-cursors {
    visibility: hidden;
  }
}

/* See issue #2901 */

.cm-tab-wrap-hack:after {
  content: '';
}

/* Help users use markselection to safely style text background */

span.CodeMirror-selectedtext {
  background: none;
}

.CodeMirror-dialog {
  background: inherit;
  color: inherit;
  left: 0;
  right: 0;
  overflow: hidden;
  padding: 0.1em 0.8em;
  position: absolute;
  z-index: 15;
}

.CodeMirror-dialog-top {
  border-bottom: 1px solid #eee;
  top: 0;
}

.CodeMirror-dialog-bottom {
  border-top: 1px solid #eee;
  bottom: 0;
}

.CodeMirror-dialog input {
  background: transparent;
  border: 1px solid #d3d6db;
  color: inherit;
  font-family: monospace;
  outline: none;
  width: 20em;
}

.CodeMirror-dialog button {
  font-size: 70%;
}

.CodeMirror-foldmarker {
  color: blue;
  cursor: pointer;
  font-family: arial;
  line-height: 0.3;
  text-shadow: #b9f 1px 1px 2px, #b9f -1px -1px 2px, #b9f 1px -1px 2px,
    #b9f -1px 1px 2px;
}

.CodeMirror-foldgutter {
  width: 0.7em;
}

.CodeMirror-foldgutter-open,
.CodeMirror-foldgutter-folded {
  cursor: pointer;
}

.CodeMirror-foldgutter-open:after {
  content: '\\25BE';
}

.CodeMirror-foldgutter-folded:after {
  content: '\\25B8';
}

.CodeMirror-info {
  background: white;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
  box-sizing: border-box;
  color: #555;
  font-family: system, -apple-system, 'San Francisco', '.SFNSDisplay-Regular',
    'Segoe UI', Segoe, 'Segoe WP', 'Helvetica Neue', helvetica, 'Lucida Grande',
    arial, sans-serif;
  font-size: 13px;
  line-height: 16px;
  margin: 8px -8px;
  max-width: 400px;
  opacity: 0;
  overflow: hidden;
  padding: 8px 8px;
  position: fixed;
  transition: opacity 0.15s;
  z-index: 50;
}

.CodeMirror-info :first-child {
  margin-top: 0;
}

.CodeMirror-info :last-child {
  margin-bottom: 0;
}

.CodeMirror-info p {
  margin: 1em 0;
}

.CodeMirror-info .info-description {
  color: #777;
  line-height: 16px;
  margin-top: 1em;
  max-height: 80px;
  overflow: hidden;
}

.CodeMirror-info .info-deprecation {
  background: #fffae8;
  box-shadow: inset 0 1px 1px -1px #bfb063;
  color: #867f70;
  line-height: 16px;
  margin: -8px;
  margin-top: 8px;
  max-height: 80px;
  overflow: hidden;
  padding: 8px;
}

.CodeMirror-info .info-deprecation-label {
  color: #c79b2e;
  cursor: default;
  display: block;
  font-size: 9px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 1;
  padding-bottom: 5px;
  text-transform: uppercase;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.CodeMirror-info .info-deprecation-label + * {
  margin-top: 0;
}

.CodeMirror-info a {
  text-decoration: none;
}

.CodeMirror-info a:hover {
  text-decoration: underline;
}

.CodeMirror-info .type-name {
  color: #ca9800;
}

.CodeMirror-info .field-name {
  color: #1f61a0;
}

.CodeMirror-info .enum-value {
  color: #0b7fc7;
}

.CodeMirror-info .arg-name {
  color: #8b2bb9;
}

.CodeMirror-info .directive-name {
  color: #b33086;
}

.CodeMirror-jump-token {
  text-decoration: underline;
  cursor: pointer;
}

/* The lint marker gutter */

.CodeMirror-lint-markers {
  width: 16px;
}

.CodeMirror-lint-tooltip {
  background-color: infobackground;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid black;
  color: infotext;
  font-family: monospace;
  font-size: 10pt;
  max-width: 600px;
  opacity: 0;
  overflow: hidden;
  padding: 2px 5px;
  position: fixed;
  transition: opacity 0.4s;
  white-space: pre-wrap;
  z-index: 100;
}

.CodeMirror-lint-mark-error,
.CodeMirror-lint-mark-warning {
  background-position: left bottom;
  background-repeat: repeat-x;
}

.CodeMirror-lint-mark-error {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sJDw4cOCW1/KIAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAHElEQVQI12NggIL/DAz/GdA5/xkY/qPKMDAwAADLZwf5rvm+LQAAAABJRU5ErkJggg==');
}

.CodeMirror-lint-mark-warning {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sJFhQXEbhTg7YAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAMklEQVQI12NkgIIvJ3QXMjAwdDN+OaEbysDA4MPAwNDNwMCwiOHLCd1zX07o6kBVGQEAKBANtobskNMAAAAASUVORK5CYII=');
}

.CodeMirror-lint-marker-error,
.CodeMirror-lint-marker-warning {
  background-position: center center;
  background-repeat: no-repeat;
  cursor: pointer;
  display: inline-block;
  height: 16px;
  position: relative;
  vertical-align: middle;
  width: 16px;
}

.CodeMirror-lint-message-error,
.CodeMirror-lint-message-warning {
  background-position: top left;
  background-repeat: no-repeat;
  padding-left: 18px;
}

.CodeMirror-lint-marker-error,
.CodeMirror-lint-message-error {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAHlBMVEW7AAC7AACxAAC7AAC7AAAAAAC4AAC5AAD///+7AAAUdclpAAAABnRSTlMXnORSiwCK0ZKSAAAATUlEQVR42mWPOQ7AQAgDuQLx/z8csYRmPRIFIwRGnosRrpamvkKi0FTIiMASR3hhKW+hAN6/tIWhu9PDWiTGNEkTtIOucA5Oyr9ckPgAWm0GPBog6v4AAAAASUVORK5CYII=');
}

.CodeMirror-lint-marker-warning,
.CodeMirror-lint-message-warning {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAANlBMVEX/uwDvrwD/uwD/uwD/uwD/uwD/uwD/uwD/uwD6twD/uwAAAADurwD2tQD7uAD+ugAAAAD/uwDhmeTRAAAADHRSTlMJ8mN1EYcbmiixgACm7WbuAAAAVklEQVR42n3PUQqAIBBFUU1LLc3u/jdbOJoW1P08DA9Gba8+YWJ6gNJoNYIBzAA2chBth5kLmG9YUoG0NHAUwFXwO9LuBQL1giCQb8gC9Oro2vp5rncCIY8L8uEx5ZkAAAAASUVORK5CYII=');
}

.CodeMirror-lint-marker-multiple {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAMAAADzjKfhAAAACVBMVEUAAAAAAAC/v7914kyHAAAAAXRSTlMAQObYZgAAACNJREFUeNo1ioEJAAAIwmz/H90iFFSGJgFMe3gaLZ0od+9/AQZ0ADosbYraAAAAAElFTkSuQmCC');
  background-position: right bottom;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}

.graphiql-container .spinner-container {
  height: 36px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 36px;
  z-index: 10;
}

.graphiql-container .spinner {
  animation: rotation 0.6s infinite linear;
  border-bottom: 6px solid rgba(150, 150, 150, 0.15);
  border-left: 6px solid rgba(150, 150, 150, 0.15);
  border-radius: 100%;
  border-right: 6px solid rgba(150, 150, 150, 0.15);
  border-top: 6px solid rgba(150, 150, 150, 0.8);
  display: inline-block;
  height: 24px;
  position: absolute;
  vertical-align: middle;
  width: 24px;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

.CodeMirror-hints {
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
  font-family: 'Consolas', 'Inconsolata', 'Droid Sans Mono', 'Monaco', monospace;
  font-size: 13px;
  list-style: none;
  margin-left: -6px;
  margin: 0;
  max-height: 14.5em;
  overflow: hidden;
  overflow-y: auto;
  padding: 0;
  position: absolute;
  z-index: 10;
}

.CodeMirror-hint {
  border-top: solid 1px #f7f7f7;
  color: #141823;
  cursor: pointer;
  margin: 0;
  max-width: 300px;
  overflow: hidden;
  padding: 2px 6px;
  white-space: pre;
}

li.CodeMirror-hint-active {
  background-color: #08f;
  border-top-color: white;
  color: white;
}

.CodeMirror-hint-information {
  border-top: solid 1px #c0c0c0;
  max-width: 300px;
  padding: 4px 6px;
  position: relative;
  z-index: 1;
}

.CodeMirror-hint-information:first-child {
  border-bottom: solid 1px #c0c0c0;
  border-top: none;
  margin-bottom: -1px;
}

.CodeMirror-hint-deprecation {
  background: #fffae8;
  box-shadow: inset 0 1px 1px -1px #bfb063;
  color: #867f70;
  font-family: system, -apple-system, 'San Francisco', '.SFNSDisplay-Regular',
    'Segoe UI', Segoe, 'Segoe WP', 'Helvetica Neue', helvetica, 'Lucida Grande',
    arial, sans-serif;
  font-size: 13px;
  line-height: 16px;
  margin-top: 4px;
  max-height: 80px;
  overflow: hidden;
  padding: 6px;
}

.CodeMirror-hint-deprecation .deprecation-label {
  color: #c79b2e;
  cursor: default;
  display: block;
  font-size: 9px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 1;
  padding-bottom: 5px;
  text-transform: uppercase;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.CodeMirror-hint-deprecation .deprecation-label + * {
  margin-top: 0;
}

.CodeMirror-hint-deprecation :last-child {
  margin-bottom: 0;
}

.graphiql-container .doc-explorer {
  background: white;
}

.graphiql-container .doc-explorer-title-bar,
.graphiql-container .history-title-bar {
  cursor: default;
  display: flex;
  align-items: center;
  position: relative;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.doc-explorer-title {
  height: 34px;
}

.graphiql-container .doc-explorer-title,
.graphiql-container .history-title {
  flex: 1;
  font-weight: bold;
  padding: 10px 0 10px 10px;
  text-align: center;
  text-overflow: ellipsis;
  -webkit-user-select: text;
     -moz-user-select: text;
          user-select: text;
  white-space: nowrap;
}

.graphiql-container .doc-explorer-back {
  color: #3b5998;
  cursor: pointer;
  margin: -7px 0 -6px -8px;
  overflow-x: hidden;
  padding: 17px 12px 16px 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: 0;
  border: 0;
  line-height: 14px;
}

.doc-explorer-narrow .doc-explorer-back {
  width: 0;
}

.graphiql-container .doc-explorer-back:before {
  border-left: 2px solid #3b5998;
  border-top: 2px solid #3b5998;
  content: '';
  display: inline-block;
  height: 9px;
  margin: 0 3px -1px 0;
  position: relative;
  transform: rotate(-45deg);
  width: 9px;
}

.graphiql-container .doc-explorer-rhs {
  position: relative;
}

.graphiql-container .doc-explorer-contents,
.graphiql-container .history-contents {
  background-color: #ffffff;
  border-top: 1px solid #d6d6d6;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  padding: 20px 15px;
  position: absolute;
  right: 0;
  top: 47px;
}

.graphiql-container .doc-explorer-contents {
  min-width: 300px;
}

.graphiql-container .doc-type-description p:first-child,
.graphiql-container .doc-type-description blockquote:first-child {
  margin-top: 0;
}

.graphiql-container .doc-explorer-contents a {
  cursor: pointer;
  text-decoration: none;
}

.graphiql-container .doc-explorer-contents a:hover {
  text-decoration: underline;
}

.graphiql-container .doc-value-description > :first-child {
  margin-top: 4px;
}

.graphiql-container .doc-value-description > :last-child {
  margin-bottom: 4px;
}

.graphiql-container .doc-type-description code,
.graphiql-container .doc-type-description pre,
.graphiql-container .doc-category code,
.graphiql-container .doc-category pre {
  --saf-0: rgba(var(--sk_foreground_low, 29, 28, 29), 0.13);
  font-size: 12px;
  line-height: 1.50001;
  font-variant-ligatures: none;
  white-space: pre;
  white-space: pre-wrap;
  word-wrap: break-word;
  word-break: normal;
  -moz-tab-size: 4;
    -o-tab-size: 4;
       tab-size: 4;
}

.graphiql-container .doc-type-description code,
.graphiql-container .doc-category code {
  padding: 2px 3px 1px;
  border: 1px solid var(--saf-0);
  border-radius: 3px;
  background-color: rgba(var(--sk_foreground_min, 29, 28, 29), 0.04);
  color: #e01e5a;
  background-color: white;
}

.graphiql-container .doc-category {
  margin: 20px 0;
}

.graphiql-container .doc-category-title {
  border-bottom: 1px solid #e0e0e0;
  color: #777;
  cursor: default;
  font-size: 14px;
  font-variant: small-caps;
  font-weight: bold;
  letter-spacing: 1px;
  margin: 0 -15px 10px 0;
  padding: 10px 0;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.graphiql-container .doc-category-item {
  margin: 12px 0;
  color: #555;
}

.graphiql-container .keyword {
  color: #b11a04;
}

.graphiql-container .type-name {
  color: #ca9800;
}

.graphiql-container .field-name {
  color: #1f61a0;
}

.graphiql-container .field-short-description {
  color: #999;
  margin-left: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.graphiql-container .enum-value {
  color: #0b7fc7;
}

.graphiql-container .arg-name {
  color: #8b2bb9;
}

.graphiql-container .arg {
  display: block;
  margin-left: 1em;
}

.graphiql-container .arg:first-child:last-child,
.graphiql-container .arg:first-child:nth-last-child(2),
.graphiql-container .arg:first-child:nth-last-child(2) ~ .arg {
  display: inherit;
  margin: inherit;
}

.graphiql-container .arg:first-child:nth-last-child(2):after {
  content: ', ';
}

.graphiql-container .arg-default-value {
  color: #43a047;
}

.graphiql-container .doc-deprecation {
  background: #fffae8;
  box-shadow: inset 0 0 1px #bfb063;
  color: #867f70;
  line-height: 16px;
  margin: 8px -8px;
  max-height: 80px;
  overflow: hidden;
  padding: 8px;
  border-radius: 3px;
}

.graphiql-container .doc-deprecation:before {
  content: 'Deprecated:';
  color: #c79b2e;
  cursor: default;
  display: block;
  font-size: 9px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 1;
  padding-bottom: 5px;
  text-transform: uppercase;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.graphiql-container .doc-deprecation > :first-child {
  margin-top: 0;
}

.graphiql-container .doc-deprecation > :last-child {
  margin-bottom: 0;
}

.graphiql-container .show-btn {
  -webkit-appearance: initial;
  display: block;
  border-radius: 3px;
  border: solid 1px #ccc;
  text-align: center;
  padding: 8px 12px 10px;
  width: 100%;
  box-sizing: border-box;
  background: #fbfcfc;
  color: #555;
  cursor: pointer;
}

.graphiql-container .search-box {
  border-bottom: 1px solid #d3d6db;
  display: block;
  font-size: 14px;
  margin: -15px -15px 12px 0;
  position: relative;
  font-weight: 400;
}

.graphiql-container .search-box:before {
  color: dimgray;
  content: '\\26b2';
  cursor: pointer;
  display: block;
  font-size: 24px;
  left: 8px;
  position: absolute;
  top: -2px;
  transform: rotate(-45deg);
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.graphiql-container .search-box .search-box-clear {
  background-color: #d0d0d0;
  border-radius: 12px;
  border: 0;
  color: #fff;
  cursor: pointer;
  font-size: 11px;
  padding: 1px 5px;
  position: absolute;
  right: 6px;
  top: 7px;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.graphiql-container .search-box .search-box-clear:hover {
  background-color: #b9b9b9;
}

.graphiql-container .search-box > input {
  border: none;
  box-sizing: border-box;
  font-size: 14px;
  outline: none;
  padding: 6px 24px 8px 28px;
  width: 100%;
}

.graphiql-container .search-box .search-box-icon {
  display: none;
}

.graphiql-container .error-container {
  font-weight: bold;
  left: 0;
  letter-spacing: 1px;
  opacity: 0.5;
  position: absolute;
  right: 0;
  text-align: center;
  text-transform: uppercase;
  top: 50%;
  transform: translate(0, -50%);
}

.CodeMirror-foldmarker {
  color: blue;
  cursor: pointer;
  font-family: arial;
  line-height: 0.3;
  text-shadow: #b9f 1px 1px 2px, #b9f -1px -1px 2px, #b9f 1px -1px 2px,
    #b9f -1px 1px 2px;
}

.CodeMirror-foldgutter {
  width: 0.7em;
}

.CodeMirror-foldgutter-open,
.CodeMirror-foldgutter-folded {
  cursor: pointer;
}

.CodeMirror-foldgutter-open:after {
  content: '\\25BE';
}

.CodeMirror-foldgutter-folded:after {
  content: '\\25B8';
}

.graphiql-container .history-contents,
.graphiql-container .history-contents input {
  font-family: 'Consolas', 'Inconsolata', 'Droid Sans Mono', 'Monaco', monospace;
}

.graphiql-container .history-contents {
  margin: 0;
  padding: 0;
}

.graphiql-container .history-contents li {
  align-items: center;
  display: flex;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  padding: 8px;
  border-bottom: 1px solid #e0e0e0;
}

.graphiql-container .history-contents li button:not(.history-label) {
  display: none;
  margin-left: 10px;
}

.graphiql-container .history-contents li:hover button:not(.history-label),
.graphiql-container
  .history-contents
  li:focus-within
  button:not(.history-label) {
  display: inline-block;
}

.graphiql-container .history-contents input,
.graphiql-container .history-contents button {
  padding: 0;
  background: 0;
  border: 0;
  font-size: inherit;
  font-family: inherit;
  line-height: 14px;
  color: inherit;
}

.graphiql-container .history-contents input {
  flex-grow: 1;
}

.graphiql-container .history-contents input::-moz-placeholder {
  color: inherit;
}

.graphiql-container .history-contents input::placeholder {
  color: inherit;
}

.graphiql-container .history-contents button {
  cursor: pointer;
  text-align: left;
}

.graphiql-container .history-contents .history-label {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.CodeMirror-info {
  background: white;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
  box-sizing: border-box;
  color: #555;
  font-family: system, -apple-system, 'San Francisco', '.SFNSDisplay-Regular',
    'Segoe UI', Segoe, 'Segoe WP', 'Helvetica Neue', helvetica, 'Lucida Grande',
    arial, sans-serif;
  font-size: 13px;
  line-height: 16px;
  margin: 8px -8px;
  max-width: 400px;
  opacity: 0;
  overflow: hidden;
  padding: 8px 8px;
  position: fixed;
  transition: opacity 0.15s;
  z-index: 50;
}

.CodeMirror-info :first-child {
  margin-top: 0;
}

.CodeMirror-info :last-child {
  margin-bottom: 0;
}

.CodeMirror-info p {
  margin: 1em 0;
}

.CodeMirror-info .info-description {
  color: #777;
  line-height: 16px;
  margin-top: 1em;
  max-height: 80px;
  overflow: hidden;
}

.CodeMirror-info .info-deprecation {
  background: #fffae8;
  box-shadow: inset 0 1px 1px -1px #bfb063;
  color: #867f70;
  line-height: 16px;
  margin: -8px;
  margin-top: 8px;
  max-height: 80px;
  overflow: hidden;
  padding: 8px;
}

.CodeMirror-info .info-deprecation-label {
  color: #c79b2e;
  cursor: default;
  display: block;
  font-size: 9px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 1;
  padding-bottom: 5px;
  text-transform: uppercase;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.CodeMirror-info .info-deprecation-label + * {
  margin-top: 0;
}

.CodeMirror-info a {
  text-decoration: none;
}

.CodeMirror-info a:hover {
  text-decoration: underline;
}

.CodeMirror-info .type-name {
  color: #ca9800;
}

.CodeMirror-info .field-name {
  color: #1f61a0;
}

.CodeMirror-info .enum-value {
  color: #0b7fc7;
}

.CodeMirror-info .arg-name {
  color: #8b2bb9;
}

.CodeMirror-info .directive-name {
  color: #b33086;
}

.CodeMirror-jump-token {
  text-decoration: underline;
  cursor: pointer;
}

/* The lint marker gutter */

.CodeMirror-lint-markers {
  width: 16px;
}

.CodeMirror-lint-tooltip {
  background-color: infobackground;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid black;
  color: infotext;
  font-family: monospace;
  font-size: 10pt;
  max-width: 600px;
  opacity: 0;
  overflow: hidden;
  padding: 2px 5px;
  position: fixed;
  transition: opacity 0.4s;
  white-space: pre-wrap;
  z-index: 100;
}

.CodeMirror-lint-mark-error,
.CodeMirror-lint-mark-warning {
  background-position: left bottom;
  background-repeat: repeat-x;
}

.CodeMirror-lint-mark-error {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sJDw4cOCW1/KIAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAHElEQVQI12NggIL/DAz/GdA5/xkY/qPKMDAwAADLZwf5rvm+LQAAAABJRU5ErkJggg==');
}

.CodeMirror-lint-mark-warning {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sJFhQXEbhTg7YAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAMklEQVQI12NkgIIvJ3QXMjAwdDN+OaEbysDA4MPAwNDNwMCwiOHLCd1zX07o6kBVGQEAKBANtobskNMAAAAASUVORK5CYII=');
}

.CodeMirror-lint-marker-error,
.CodeMirror-lint-marker-warning {
  background-position: center center;
  background-repeat: no-repeat;
  cursor: pointer;
  display: inline-block;
  height: 16px;
  position: relative;
  vertical-align: middle;
  width: 16px;
}

.CodeMirror-lint-message-error,
.CodeMirror-lint-message-warning {
  background-position: top left;
  background-repeat: no-repeat;
  padding-left: 18px;
}

.CodeMirror-lint-marker-error,
.CodeMirror-lint-message-error {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAHlBMVEW7AAC7AACxAAC7AAC7AAAAAAC4AAC5AAD///+7AAAUdclpAAAABnRSTlMXnORSiwCK0ZKSAAAATUlEQVR42mWPOQ7AQAgDuQLx/z8csYRmPRIFIwRGnosRrpamvkKi0FTIiMASR3hhKW+hAN6/tIWhu9PDWiTGNEkTtIOucA5Oyr9ckPgAWm0GPBog6v4AAAAASUVORK5CYII=');
}

.CodeMirror-lint-marker-warning,
.CodeMirror-lint-message-warning {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAANlBMVEX/uwDvrwD/uwD/uwD/uwD/uwD/uwD/uwD/uwD6twD/uwAAAADurwD2tQD7uAD+ugAAAAD/uwDhmeTRAAAADHRSTlMJ8mN1EYcbmiixgACm7WbuAAAAVklEQVR42n3PUQqAIBBFUU1LLc3u/jdbOJoW1P08DA9Gba8+YWJ6gNJoNYIBzAA2chBth5kLmG9YUoG0NHAUwFXwO9LuBQL1giCQb8gC9Oro2vp5rncCIY8L8uEx5ZkAAAAASUVORK5CYII=');
}

.CodeMirror-lint-marker-multiple {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAMAAADzjKfhAAAACVBMVEUAAAAAAAC/v7914kyHAAAAAXRSTlMAQObYZgAAACNJREFUeNo1ioEJAAAIwmz/H90iFFSGJgFMe3gaLZ0od+9/AQZ0ADosbYraAAAAAElFTkSuQmCC');
  background-position: right bottom;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}

.graphiql-container .spinner-container {
  height: 36px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 36px;
  z-index: 10;
}

.graphiql-container .spinner {
  animation: rotation 0.6s infinite linear;
  border-bottom: 6px solid rgba(150, 150, 150, 0.15);
  border-left: 6px solid rgba(150, 150, 150, 0.15);
  border-radius: 100%;
  border-right: 6px solid rgba(150, 150, 150, 0.15);
  border-top: 6px solid rgba(150, 150, 150, 0.8);
  display: inline-block;
  height: 24px;
  position: absolute;
  vertical-align: middle;
  width: 24px;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

.CodeMirror-hints {
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
  font-family: 'Consolas', 'Inconsolata', 'Droid Sans Mono', 'Monaco', monospace;
  font-size: 13px;
  list-style: none;
  margin-left: -6px;
  margin: 0;
  max-height: 14.5em;
  overflow-y: auto;
  overflow: hidden;
  padding: 0;
  position: absolute;
  z-index: 10;
}

.CodeMirror-hint {
  border-top: solid 1px #f7f7f7;
  color: #141823;
  cursor: pointer;
  margin: 0;
  max-width: 300px;
  overflow: hidden;
  padding: 2px 6px;
  white-space: pre;
}

li.CodeMirror-hint-active {
  background-color: #08f;
  border-top-color: white;
  color: white;
}

.CodeMirror-hint-information {
  border-top: solid 1px #c0c0c0;
  max-width: 300px;
  padding: 4px 6px;
  position: relative;
  z-index: 1;
}

.CodeMirror-hint-information:first-child {
  border-bottom: solid 1px #c0c0c0;
  border-top: none;
  margin-bottom: -1px;
}

.CodeMirror-hint-deprecation {
  background: #fffae8;
  box-shadow: inset 0 1px 1px -1px #bfb063;
  color: #867f70;
  font-family: system, -apple-system, 'San Francisco', '.SFNSDisplay-Regular',
    'Segoe UI', Segoe, 'Segoe WP', 'Helvetica Neue', helvetica, 'Lucida Grande',
    arial, sans-serif;
  font-size: 13px;
  line-height: 16px;
  margin-top: 4px;
  max-height: 80px;
  overflow: hidden;
  padding: 6px;
}

.CodeMirror-hint-deprecation .deprecation-label {
  color: #c79b2e;
  cursor: default;
  display: block;
  font-size: 9px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 1;
  padding-bottom: 5px;
  text-transform: uppercase;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.CodeMirror-hint-deprecation .deprecation-label + * {
  margin-top: 0;
}

.CodeMirror-hint-deprecation :last-child {
  margin-bottom: 0;
}

.graphiql_footer {
  display: flex;
  align-items: center;
  position: sticky;
  bottom: 0;
  width: 100%;
  padding: 8px;
  background: #eee;
  z-index: 100;
}

.graphiql_footer_label {
  font-size: 10px;
  color: #777777;
  font-weight: 600;
  margin-right: 8px;
  text-transform: uppercase;
}

.graphiql_footer_value {
  margin-right: 16px;
  font-size: 13px;
}

.graphiql_footer_icon {
  color: #777;
  margin-right: 8px;
  margin-left: 0px;
}

.color_green {
  color: #047857 !important;
}

.graphiql-explorer-node > span > svg {
  margin-left: 0px !important;
}

.graphiql-code-exporter .CodeMirror {
  position: relative;
  font-size: 11px;
  background: transparent;
}

.graphiql-code-exporter .CodeMirror-lines {
  padding-top: 0;
}
`, "",{"version":3,"sources":["webpack://./../../libs/console/legacy-ce/src/lib/components/Services/ApiExplorer/GraphiQLWrapper/GraphiQL.css"],"names":[],"mappings":"AAAA;;;EAGE,cAAc;EACd;;qBAEmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EAQnB,6CAA6C;EAC7C,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EASE,6CAA6C;EAC7C,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,SAAS;EACT,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,uCAAuC;EACvC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;EAC7B,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA,0DAA0D;;AAE1D;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EAQnB,6CAA6C;EAC7C,kBAAkB;EAClB;sDACoD;EACpD,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAQE,6CAA6C;EAC7C;;oCAEkC;AACpC;;AAEA;EAQE,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EAQE,6CAA6C;EAC7C,mBAAmB;EACnB,qCAAqC;EACrC,wBAAwB;EACxB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EAQE,6CAA6C;EAC7C;oCACkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;EAChB,uEAAuE;EACvE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;;;;;;EASE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,8EAA8E;EAC9E,eAAe;EACf,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb;;qBAEmB;EACnB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,+CAA+C;EAC/C,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE;;IAEE,kCAAkC;IAClC,oCAAoC;EACtC;;EAEA;;IAEE,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,yCAAyC;EACzC;;qBAEmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,gBAAgB;EAQhB,6CAA6C;EAC7C,4EAA4E;EAC5E,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA,YAAY;;AACZ;EACE,WAAW;AACb;;AAEA,gBAAgB;;AAChB;EACE,WAAW;AACb;;AAEA,YAAY;;AACZ;EACE,cAAc;AAChB;;AAEA,gCAAgC;;AAChC;EACE,cAAc;AAChB;;AAEA,cAAc;;AACd;EACE,cAAc;AAChB;;AAEA,eAAe;;AACf;EACE,cAAc;AAChB;;AAEA,qCAAqC;;AACrC;EACE,cAAc;AAChB;;AAEA,WAAW;;AACX;EACE,cAAc;AAChB;;AAEA,WAAW;;AACX;EACE,cAAc;AAChB;;AAEA,YAAY;;AACZ;EACE,cAAc;AAChB;;AAEA,cAAc;;AACd;EACE,cAAc;AAChB;;AAEA,aAAa;;AACb;EACE,cAAc;AAChB;;AAEA,cAAc;;AACd;EACE,cAAc;AAChB;;AAEA,SAAS;;AACT;EACE,cAAc;AAChB;;AACA,6BAA6B;;AAC7B;EACE,UAAU;EACV,qBAAqB;AACvB;;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;AACf;;AACA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,2CAA2C;EAC3C,YAAY;AACd;;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AACA;EACE,SAAS;EACT,6BAA6B;EAC7B,WAAW;AACb;;AACA;EACE,aAAa;AACf;;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AACA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AACA;EACE,0BAAyB;UAAzB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AACA;EACE,cAAc;AAChB;;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;;AAEX;EACE,gEAAgE;EAChE,YAAY;EACZ,sBAAsB;EACtB,aAAa;AACf;;AAEA,YAAY;;AAEZ;EACE,cAAc,EAAE,oCAAoC;AACtD;;AAEA;EACE,cAAc,EAAE,kCAAkC;AACpD;;AAEA;;EAEE,uBAAuB,EAAE,iDAAiD;AAC5E;;AAEA,WAAW;;AAEX;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;AACA;;AAEA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,WAAW;;AAEX;EACE,4BAA4B;AAC9B;;AAEA,6CAA6C;;AAE7C;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,8DAA8D;;AAE9D;AACA;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,kBAAkB;;AAElB;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;AAIA;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qCAAqC;;AAErC;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;;AAET;mDACmD;;AAEnD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,wEAAwE;EACxE,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,aAAa,EAAE,mDAAmD;EAClE,2BAA2B,EAAE,4CAA4C;EACzE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;0BAE0B;;AAE1B;;;;EAIE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,OAAO;EACP,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;GAC5B,OAAQ;GACR,eAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe,EAAE,0CAA0C;AAC7D;;AAEA;EACE,wCAAwC;EACxC,+DAA+D;EAC/D,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;EACpB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;AACA;;AAEA;EACE,aAAa;AACf;;AAEA,iEAAiE;;AAEjE;;;;;EAKE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAGE,mBAAmB;AACrB;;AAJA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,wEAAwE;;AAExE;GACE,2BAA4B;AAC9B;;AAEA,4CAA4C;;AAE5C;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC;IACE,kBAAkB;EACpB;AACF;;AAEA,oBAAoB;;AAEpB;EACE,WAAW;AACb;;AAEA,iEAAiE;;AAEjE;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,MAAM;AACR;;AAEA;EACE,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB;qBACmB;AACrB;;AACA;EACE,YAAY;AACd;;AACA;;EAEE,eAAe;AACjB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,sBAAsB;EACtB,WAAW;EACX;;qBAEmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,2BAA2B;;AAC3B;EACE,WAAW;AACb;;AACA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,YAAY;AACd;;AACA;;EAEE,gCAAgC;EAChC,2BAA2B;AAC7B;;AACA;EACE,mTAAmT;AACrT;;AACA;EACE,+UAA+U;AACjV;;AACA;;EAEE,kCAAkC;EAClC,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AACA;;EAEE,6BAA6B;EAC7B,4BAA4B;EAC5B,kBAAkB;AACpB;;AACA;;EAEE,mTAAmT;AACrT;;AACA;;EAEE,uWAAuW;AACzW;;AACA;EACE,uNAAuN;EACvN,iCAAiC;EACjC,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,kDAAkD;EAClD,gDAAgD;EAChD,mBAAmB;EACnB,iDAAiD;EACjD,8CAA8C;EAC9C,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,8EAA8E;EAC9E,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;EACd;;qBAEmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AACA;EACE,YAAY;AACd;;AACA;;EAEE,OAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,6BAA6B;EAC7B,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,yDAAyD;EACzD,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAW;IAAX,cAAW;OAAX,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,kEAAkE;EAClE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,OAAO;EACP,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,6BAA6B;AAC/B;;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB;qBACmB;AACrB;;AACA;EACE,YAAY;AACd;;AACA;;EAEE,eAAe;AACjB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;;EAEE,8EAA8E;AAChF;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;EACV,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAFA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,sBAAsB;EACtB,WAAW;EACX;;qBAEmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AACA,2BAA2B;;AAC3B;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,YAAY;AACd;;AAEA;;EAEE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mTAAmT;AACrT;;AAEA;EACE,+UAA+U;AACjV;;AAEA;;EAEE,kCAAkC;EAClC,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,6BAA6B;EAC7B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;EAEE,mTAAmT;AACrT;;AAEA;;EAEE,uWAAuW;AACzW;;AAEA;EACE,uNAAuN;EACvN,iCAAiC;EACjC,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;;AACA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,kDAAkD;EAClD,gDAAgD;EAChD,mBAAmB;EACnB,iDAAiD;EACjD,8CAA8C;EAC9C,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AACA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,8EAA8E;EAC9E,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;EACd;;qBAEmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AACA;EACE,cAAc;AAChB","sourcesContent":[".graphiql-container,\n.graphiql-container button,\n.graphiql-container input {\n  color: #141823;\n  font-family: system, -apple-system, 'San Francisco', '.SFNSDisplay-Regular',\n    'Segoe UI', Segoe, 'Segoe WP', 'Helvetica Neue', helvetica, 'Lucida Grande',\n    arial, sans-serif;\n  font-size: 14px;\n}\n\n.graphiql-container {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n  width: 100%;\n}\n\n.graphiql-container .editorWrap {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow-x: hidden;\n}\n\n.graphiql-container .title {\n  font-size: 18px;\n}\n\n.graphiql-container .title em {\n  font-family: georgia;\n  font-size: 19px;\n}\n\n.graphiql-container .topBarWrap {\n  display: flex;\n  flex-direction: row;\n}\n\n.graphiql-container .topBar {\n  align-items: center;\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    from(#f7f7f7),\n    to(#e2e2e2)\n  );\n  background: linear-gradient(#f7f7f7, #e2e2e2);\n  border-bottom: 1px solid #d0d0d0;\n  cursor: default;\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  height: 34px;\n  overflow-y: visible;\n  padding: 7px 14px 6px;\n  user-select: none;\n}\n\n.graphiql-container .toolbar {\n  overflow-x: visible;\n  display: flex;\n}\n\n.graphiql-container .docExplorerShow,\n.graphiql-container .historyShow {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    from(#f7f7f7),\n    to(#e2e2e2)\n  );\n  background: linear-gradient(#f7f7f7, #e2e2e2);\n  border-radius: 0;\n  border-bottom: 1px solid #d0d0d0;\n  border-right: none;\n  border-top: none;\n  color: #3b5998;\n  cursor: pointer;\n  font-size: 14px;\n  margin: 0;\n  outline: 0;\n  padding: 2px 20px 0 18px;\n}\n\n.graphiql-container .docExplorerShow {\n  border-left: 1px solid rgba(0, 0, 0, 0.2);\n}\n\n.graphiql-container .historyShow {\n  border-right: 1px solid rgba(0, 0, 0, 0.2);\n  border-left: 0;\n}\n\n.graphiql-container .docExplorerShow:before {\n  border-left: 2px solid #3b5998;\n  border-top: 2px solid #3b5998;\n  content: '';\n  display: inline-block;\n  height: 9px;\n  margin: 0 3px -1px 0;\n  position: relative;\n  transform: rotate(-45deg);\n  width: 9px;\n}\n\n.graphiql-container .editorBar {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n}\n\n.graphiql-container .queryWrap {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.graphiql-container .resultWrap {\n  border-left: solid 1px #e0e0e0;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  position: relative;\n}\n\n.graphiql-container .docExplorerWrap,\n.graphiql-container .historyPaneWrap {\n  background: white;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);\n  position: relative;\n  z-index: 3;\n}\n\n.graphiql-container .historyPaneWrap {\n  min-width: 230px;\n  z-index: 5;\n}\n\n.graphiql-container .docExplorerResizer {\n  cursor: col-resize;\n  height: 100%;\n  left: -5px;\n  position: absolute;\n  top: 0;\n  width: 10px;\n  z-index: 10;\n}\n\n.graphiql-container .docExplorerHide {\n  cursor: pointer;\n  font-size: 18px;\n  margin: -7px -8px -6px 0;\n  padding: 18px 16px 15px 12px;\n}\n\n.graphiql-container div .query-editor {\n  flex: 1;\n  position: relative;\n}\n\n.graphiql-container .variable-editor {\n  display: flex;\n  flex-direction: column;\n  height: 30px;\n  position: relative;\n}\n\n.graphiql-container .variable-editor-title {\n  background: #eeeeee;\n  border-bottom: 1px solid #d6d6d6;\n  border-top: 1px solid #e0e0e0;\n  color: #777;\n  font-variant: small-caps;\n  font-weight: bold;\n  letter-spacing: 1px;\n  line-height: 14px;\n  padding: 6px 0 8px 43px;\n  text-transform: lowercase;\n  user-select: none;\n}\n\n.graphiql-container .codemirrorWrap {\n  flex: 1;\n  height: 100%;\n  position: relative;\n}\n\n.graphiql-container .result-window {\n  flex: 1;\n  height: 100%;\n  position: relative;\n}\n\n.graphiql-container .footer {\n  background: #f6f7f8;\n  border-left: 1px solid #e0e0e0;\n  border-top: 1px solid #e0e0e0;\n  margin-left: 12px;\n  position: relative;\n}\n\n.graphiql-container .footer:before {\n  background: #eeeeee;\n  bottom: 0;\n  content: ' ';\n  left: -13px;\n  position: absolute;\n  top: -1px;\n  width: 12px;\n}\n\n/* No `.graphiql-container` here so themes can overwrite */\n\n.result-window .CodeMirror {\n  background: #f6f7f8;\n}\n\n.graphiql-container .result-window .CodeMirror-gutters {\n  background-color: #eeeeee;\n  border-color: #e0e0e0;\n  cursor: col-resize;\n}\n\n.graphiql-container .result-window .CodeMirror-foldgutter,\n.graphiql-container .result-window .CodeMirror-foldgutter-open:after,\n.graphiql-container .result-window .CodeMirror-foldgutter-folded:after {\n  padding-left: 3px;\n}\n\n.graphiql-container .toolbar-button {\n  background: #fdfdfd;\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    from(#f9f9f9),\n    to(#ececec)\n  );\n  background: linear-gradient(#f9f9f9, #ececec);\n  border-radius: 3px;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.2),\n    0 1px 0 rgba(255, 255, 255, 0.7), inset 0 1px #fff;\n  color: #555;\n  cursor: pointer;\n  display: inline-block;\n  margin: 0 5px;\n  padding: 3px 11px 3px;\n  text-decoration: none;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 150px;\n}\n\n.graphiql-container .toolbar-button span i {\n  margin-left: 5px;\n}\n\n.graphiql-container .toolbar-button:active {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    from(#ececec),\n    to(#d5d5d5)\n  );\n  background: linear-gradient(#ececec, #d5d5d5);\n  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.7),\n    inset 0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 1px 1px 1px rgba(0, 0, 0, 0.12),\n    inset 0 0 5px rgba(0, 0, 0, 0.1);\n}\n\n.graphiql-container .toolbar-button.error {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    from(#fdf3f3),\n    to(#e6d6d7)\n  );\n  background: linear-gradient(#fdf3f3, #e6d6d7);\n  color: #b00;\n}\n\n.graphiql-container .toolbar-button.primary {\n  background: #f9c548;\n  border: 1px solid #d5ae52;\n  box-shadow: none;\n  color: #475569;\n  font-weight: 500;\n}\n\n.graphiql-container .toolbar-button-group {\n  margin: 0 5px;\n  white-space: nowrap;\n}\n\n.graphiql-container .toolbar-button-group > * {\n  margin: 0;\n}\n\n.graphiql-container .toolbar-button-group > *:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.graphiql-container .toolbar-button-group > *:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  margin-left: -1px;\n}\n\n.graphiql-container .execute-button-wrap {\n  height: 34px;\n  margin: 0 14px 0 28px;\n  position: relative;\n}\n\n.graphiql-container .execute-button {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    from(#fdfdfd),\n    to(#d2d3d6)\n  );\n  background: linear-gradient(#fdfdfd, #d2d3d6);\n  border-radius: 17px;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  box-shadow: 0 1px 0 #fff;\n  cursor: pointer;\n  fill: #444;\n  height: 34px;\n  margin: 0;\n  padding: 0;\n  width: 34px;\n}\n\n.graphiql-container .execute-button svg {\n  pointer-events: none;\n}\n\n.graphiql-container .execute-button:active {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    from(#e6e6e6),\n    to(#c3c3c3)\n  );\n  background: linear-gradient(#e6e6e6, #c3c3c3);\n  box-shadow: 0 1px 0 #fff, inset 0 0 2px rgba(0, 0, 0, 0.2),\n    inset 0 0 6px rgba(0, 0, 0, 0.1);\n}\n\n.graphiql-container .execute-button:focus {\n  outline: 0;\n}\n\n.graphiql-container .toolbar-menu,\n.graphiql-container .toolbar-select {\n  position: relative;\n}\n\n.graphiql-container .execute-options,\n.graphiql-container .toolbar-menu-items,\n.graphiql-container .toolbar-select-options {\n  background: #fff;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.25);\n  margin: 0;\n  padding: 6px 0;\n  position: absolute;\n  z-index: 100;\n}\n\n.graphiql-container .execute-options {\n  min-width: 100px;\n  top: 37px;\n  left: -1px;\n}\n\n.graphiql-container .toolbar-menu-items {\n  left: 1px;\n  margin-top: -1px;\n  min-width: 110%;\n  top: 100%;\n  visibility: hidden;\n}\n\n.graphiql-container .toolbar-menu-items.open {\n  visibility: visible;\n}\n\n.graphiql-container .toolbar-select-options {\n  left: 0;\n  min-width: 100%;\n  top: -5px;\n  visibility: hidden;\n}\n\n.graphiql-container .toolbar-select-options.open {\n  visibility: visible;\n}\n\n.graphiql-container .execute-options > li,\n.graphiql-container .toolbar-menu-items > li,\n.graphiql-container .toolbar-select-options > li {\n  cursor: pointer;\n  display: block;\n  margin: none;\n  max-width: 300px;\n  overflow: hidden;\n  padding: 2px 20px 4px 11px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.graphiql-container .execute-options > li.selected,\n.graphiql-container .toolbar-menu-items > li.hover,\n.graphiql-container .toolbar-menu-items > li:active,\n.graphiql-container .toolbar-menu-items > li:hover,\n.graphiql-container .toolbar-select-options > li.hover,\n.graphiql-container .toolbar-select-options > li:active,\n.graphiql-container .toolbar-select-options > li:hover,\n.graphiql-container .history-contents > li:hover,\n.graphiql-container .history-contents > li:active {\n  background: #e10098;\n  color: #fff;\n}\n\n.graphiql-container .toolbar-select-options > li > svg {\n  display: inline;\n  fill: #666;\n  margin: 0 -6px 0 6px;\n  pointer-events: none;\n  vertical-align: middle;\n}\n\n.graphiql-container .toolbar-select-options > li.hover > svg,\n.graphiql-container .toolbar-select-options > li:active > svg,\n.graphiql-container .toolbar-select-options > li:hover > svg {\n  fill: #fff;\n}\n\n.graphiql-container .CodeMirror-scroll {\n  overflow-scrolling: touch;\n}\n\n.graphiql-container .CodeMirror {\n  color: #141823;\n  font-family: 'Consolas', 'Inconsolata', 'Droid Sans Mono', 'Monaco', monospace;\n  font-size: 13px;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.graphiql-container .CodeMirror-lines {\n  padding: 20px 0;\n}\n\n.CodeMirror-hint-information .content {\n  box-orient: vertical;\n  color: #141823;\n  display: flex;\n  font-family: system, -apple-system, 'San Francisco', '.SFNSDisplay-Regular',\n    'Segoe UI', Segoe, 'Segoe WP', 'Helvetica Neue', helvetica, 'Lucida Grande',\n    arial, sans-serif;\n  font-size: 13px;\n  line-clamp: 3;\n  line-height: 16px;\n  max-height: 48px;\n  overflow: hidden;\n  text-overflow: -o-ellipsis-lastline;\n}\n\n.CodeMirror-hint-information .content p:first-child {\n  margin-top: 0;\n}\n\n.CodeMirror-hint-information .content p:last-child {\n  margin-bottom: 0;\n}\n\n.CodeMirror-hint-information .infoType {\n  color: #ca9800;\n  cursor: pointer;\n  display: inline;\n  margin-right: 0.5em;\n}\n\n.autoInsertedLeaf.cm-property {\n  animation-duration: 6s;\n  animation-name: insertionFade;\n  border-bottom: 2px solid rgba(255, 255, 255, 0);\n  border-radius: 2px;\n  margin: -2px -4px -1px;\n  padding: 2px 4px 1px;\n}\n\n@keyframes insertionFade {\n  from,\n  to {\n    background: rgba(255, 255, 255, 0);\n    border-color: rgba(255, 255, 255, 0);\n  }\n\n  15%,\n  85% {\n    background: #fbffc9;\n    border-color: #f0f3c0;\n  }\n}\n\ndiv.CodeMirror-lint-tooltip {\n  background-color: white;\n  border-radius: 2px;\n  border: 0;\n  color: #141823;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);\n  font-family: system, -apple-system, 'San Francisco', '.SFNSDisplay-Regular',\n    'Segoe UI', Segoe, 'Segoe WP', 'Helvetica Neue', helvetica, 'Lucida Grande',\n    arial, sans-serif;\n  font-size: 13px;\n  line-height: 16px;\n  max-width: 430px;\n  opacity: 0;\n  padding: 8px 10px;\n  transition: opacity 0.15s;\n  white-space: pre-wrap;\n}\n\ndiv.CodeMirror-lint-tooltip > * {\n  padding-left: 23px;\n}\n\ndiv.CodeMirror-lint-tooltip > * + * {\n  margin-top: 12px;\n}\n\n/* COLORS */\n\n.graphiql-container .CodeMirror-foldmarker {\n  border-radius: 4px;\n  background: #08f;\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    from(#43a8ff),\n    to(#0f83e8)\n  );\n  background: linear-gradient(#43a8ff, #0f83e8);\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2), inset 0 0 0 1px rgba(0, 0, 0, 0.1);\n  color: white;\n  font-family: arial;\n  font-size: 12px;\n  line-height: 0;\n  margin: 0 3px;\n  padding: 0px 4px 1px;\n  text-shadow: 0 -1px rgba(0, 0, 0, 0.1);\n}\n\n.graphiql-container div.CodeMirror span.CodeMirror-matchingbracket {\n  color: #555;\n  text-decoration: underline;\n}\n\n.graphiql-container div.CodeMirror span.CodeMirror-nonmatchingbracket {\n  color: #f00;\n}\n\n/* Comment */\n.cm-comment {\n  color: #999;\n}\n\n/* Punctuation */\n.cm-punctuation {\n  color: #555;\n}\n\n/* Keyword */\n.cm-keyword {\n  color: #b11a04;\n}\n\n/* OperationName, FragmentName */\n.cm-def {\n  color: #d2054e;\n}\n\n/* FieldName */\n.cm-property {\n  color: #1f61a0;\n}\n\n/* FieldAlias */\n.cm-qualifier {\n  color: #1c92a9;\n}\n\n/* ArgumentName and ObjectFieldName */\n.cm-attribute {\n  color: #8b2bb9;\n}\n\n/* Number */\n.cm-number {\n  color: #2882f9;\n}\n\n/* String */\n.cm-string {\n  color: #d64292;\n}\n\n/* Boolean */\n.cm-builtin {\n  color: #d47509;\n}\n\n/* EnumValue */\n.cm-string-2 {\n  color: #0b7fc7;\n}\n\n/* Variable */\n.cm-variable {\n  color: #397d13;\n}\n\n/* Directive */\n.cm-meta {\n  color: #b33086;\n}\n\n/* Type */\n.cm-atom {\n  color: #ca9800;\n}\n/* Hasura Analyse modal css */\n.wd25 {\n  width: 25%;\n  display: inline-block;\n}\n.wd75 {\n  width: 75%;\n  display: inline-block;\n}\n.wd40 {\n  width: 40%;\n  display: inline-block;\n}\n.wd60 {\n  width: 60%;\n  display: inline-block;\n}\n.modalWrapper {\n  position: absolute;\n  top: 40px;\n  left: 40px;\n  right: 40px;\n  bottom: 40px;\n  border: 1px solid rgb(204, 204, 204);\n  background: rgb(255, 255, 255);\n  border-radius: 4px;\n  outline: none;\n}\n.myOverlayClass {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  background-color: rgba(255, 255, 255, 0.75);\n  z-index: 100;\n}\n.modalHeader {\n  background-color: #43495a;\n  border-bottom: 1px solid #ccc;\n  padding: 10px 20px;\n  position: relative;\n  color: #ffc627;\n}\n.modalTitle {\n  font-size: 18px;\n  font-weight: 500;\n}\n.modalClose {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n.modalClose button {\n  cursor: pointer;\n  border-radius: 5px;\n  border: 0;\n  background-color: transparent;\n  font-size: 16px;\n  font-weight: 700;\n  color: #ccc;\n  padding: 0px;\n  height: auto;\n}\n.modalClose button:hover {\n  border: 0;\n  background-color: transparent;\n  color: #fff;\n}\n.modalClose button:focus {\n  outline: none;\n}\n.modalBody {\n  display: flex;\n  height: calc(100% - 46px);\n}\n.topLevelNodesWrapper {\n  border-right: 1px solid #ccc;\n  height: 100%;\n}\n\n.textCenter {\n  text-align: center;\n}\n.topLevelNodesWrapper .title {\n  padding: 15px 20px;\n  background-color: #fff3d5;\n  margin-bottom: 20px;\n  color: #767e93;\n  font-weight: 600;\n  font-size: 16px;\n}\n.analysisWrapper {\n  height: 100%;\n  position: relative;\n  width: 100%;\n}\n.topLevelNodesWrapper ul {\n  padding-inline-start: 0px;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.borderRight {\n  border-right: 1px solid #ccc;\n}\n\n.topLevelNodesWrapper ul li {\n  list-style-type: none;\n  padding: 10px 0;\n  padding-left: 20px;\n  cursor: pointer;\n}\n\n.topLevelNodesWrapper ul li i {\n  margin-right: 5px;\n  font-size: 12px;\n}\n\n.topLevelNodesWrapper ul li.active {\n  color: #fd9540;\n}\n.topLevelNodesWrapper ul li:hover {\n  color: #e2701a;\n}\n.plansWrapper {\n  height: 50%;\n  position: relative;\n  padding: 0px 20px;\n}\n.plansTitle {\n  padding: 10px 0px;\n  color: #767e93;\n  font-weight: 600;\n}\n\n/* BASICS */\n\n.CodeMirror {\n  /* Set height, width, borders, and global font properties here */\n  color: black;\n  font-family: monospace;\n  height: 300px;\n}\n\n/* PADDING */\n\n.CodeMirror-lines {\n  padding: 4px 0; /* Vertical padding around content */\n}\n\n.CodeMirror pre {\n  padding: 0 4px; /* Horizontal padding of content */\n}\n\n.CodeMirror-scrollbar-filler,\n.CodeMirror-gutter-filler {\n  background-color: white; /* The little square between H and V scrollbars */\n}\n\n/* GUTTER */\n\n.CodeMirror-gutters {\n  border-right: 1px solid #ddd;\n  background-color: #f7f7f7;\n  white-space: nowrap;\n}\n\n.CodeMirror-linenumbers {\n}\n\n.CodeMirror-linenumber {\n  color: #999;\n  min-width: 20px;\n  padding: 0 3px 0 5px;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.CodeMirror-guttermarker {\n  color: black;\n}\n\n.CodeMirror-guttermarker-subtle {\n  color: #999;\n}\n\n/* CURSOR */\n\n.CodeMirror .CodeMirror-cursor {\n  border-left: 1px solid black;\n}\n\n/* Shown when moving in bi-directional text */\n\n.CodeMirror div.CodeMirror-secondarycursor {\n  border-left: 1px solid silver;\n}\n\n.CodeMirror.cm-fat-cursor div.CodeMirror-cursor {\n  background: #7e7;\n  border: 0;\n  width: auto;\n}\n\n.CodeMirror.cm-fat-cursor div.CodeMirror-cursors {\n  z-index: 1;\n}\n\n.cm-animate-fat-cursor {\n  animation: blink 1.06s steps(1) infinite;\n  border: 0;\n  width: auto;\n}\n\n@keyframes blink {\n  0% {\n    background: #7e7;\n  }\n  50% {\n    background: none;\n  }\n  100% {\n    background: #7e7;\n  }\n}\n\n/* Can style cursor different in overwrite (non-insert) mode */\n\ndiv.CodeMirror-overwrite div.CodeMirror-cursor {\n}\n\n.cm-tab {\n  display: inline-block;\n  text-decoration: inherit;\n}\n\n.CodeMirror-ruler {\n  border-left: 1px solid #ccc;\n  position: absolute;\n}\n\n/* DEFAULT THEME */\n\n.cm-s-default .cm-keyword {\n  color: #708;\n}\n\n.cm-s-default .cm-atom {\n  color: #219;\n}\n\n.cm-s-default .cm-number {\n  color: #164;\n}\n\n.cm-s-default .cm-def {\n  color: #00f;\n}\n\n.cm-s-default .cm-variable,\n.cm-s-default .cm-punctuation,\n.cm-s-default .cm-property,\n.cm-s-default .cm-operator {\n}\n\n.cm-s-default .cm-variable-2 {\n  color: #05a;\n}\n\n.cm-s-default .cm-variable-3 {\n  color: #085;\n}\n\n.cm-s-default .cm-comment {\n  color: #a50;\n}\n\n.cm-s-default .cm-string {\n  color: #a11;\n}\n\n.cm-s-default .cm-string-2 {\n  color: #f50;\n}\n\n.cm-s-default .cm-meta {\n  color: #555;\n}\n\n.cm-s-default .cm-qualifier {\n  color: #555;\n}\n\n.cm-s-default .cm-builtin {\n  color: #30a;\n}\n\n.cm-s-default .cm-bracket {\n  color: #997;\n}\n\n.cm-s-default .cm-tag {\n  color: #170;\n}\n\n.cm-s-default .cm-attribute {\n  color: #00c;\n}\n\n.cm-s-default .cm-header {\n  color: blue;\n}\n\n.cm-s-default .cm-quote {\n  color: #090;\n}\n\n.cm-s-default .cm-hr {\n  color: #999;\n}\n\n.cm-s-default .cm-link {\n  color: #00c;\n}\n\n.cm-negative {\n  color: #d44;\n}\n\n.cm-positive {\n  color: #292;\n}\n\n.cm-header,\n.cm-strong {\n  font-weight: bold;\n}\n\n.cm-em {\n  font-style: italic;\n}\n\n.cm-link {\n  text-decoration: underline;\n}\n\n.cm-strikethrough {\n  text-decoration: line-through;\n}\n\n.cm-s-default .cm-error {\n  color: #f00;\n}\n\n.cm-invalidchar {\n  color: #f00;\n}\n\n.CodeMirror-composing {\n  border-bottom: 2px solid;\n}\n\n/* Default styles for common addons */\n\ndiv.CodeMirror span.CodeMirror-matchingbracket {\n  color: #0f0;\n}\n\ndiv.CodeMirror span.CodeMirror-nonmatchingbracket {\n  color: #f22;\n}\n\n.CodeMirror-matchingtag {\n  background: rgba(255, 150, 0, 0.3);\n}\n\n.CodeMirror-activeline-background {\n  background: #e8f2ff;\n}\n\n/* STOP */\n\n/* The rest of this file contains styles related to the mechanics of\n   the editor. You probably shouldn't touch them. */\n\n.CodeMirror {\n  background: white;\n  overflow: hidden;\n  position: relative;\n}\n\n.CodeMirror-scroll {\n  height: 100%;\n  /* 30px is the magic margin used to hide the element's real scrollbars */\n  /* See overflow: hidden in .CodeMirror */\n  margin-bottom: -30px;\n  margin-right: -30px;\n  outline: none; /* Prevent dragging from highlighting the element */\n  overflow: scroll !important; /* Things will break if this is overridden */\n  padding-bottom: 30px;\n  position: relative;\n}\n\n.CodeMirror-sizer {\n  border-right: 30px solid transparent;\n  position: relative;\n}\n\n/* The fake, visible scrollbars. Used to force redraw during scrolling\n   before actual scrolling happens, thus preventing shaking and\n   flickering artifacts. */\n\n.CodeMirror-vscrollbar,\n.CodeMirror-hscrollbar,\n.CodeMirror-scrollbar-filler,\n.CodeMirror-gutter-filler {\n  display: none;\n  position: absolute;\n  z-index: 6;\n}\n\n.CodeMirror-vscrollbar {\n  overflow-x: hidden;\n  overflow-y: scroll;\n  right: 0;\n  top: 0;\n}\n\n.CodeMirror-hscrollbar {\n  bottom: 0;\n  left: 0;\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n\n.CodeMirror-scrollbar-filler {\n  right: 0;\n  bottom: 0;\n}\n\n.CodeMirror-gutter-filler {\n  left: 0;\n  bottom: 0;\n}\n\n.CodeMirror-gutters {\n  min-height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 3;\n}\n\n.CodeMirror-gutter {\n  display: inline-block;\n  height: 100%;\n  margin-bottom: -30px;\n  vertical-align: top;\n  white-space: normal;\n  /* Hack to make IE7 behave */\n  *zoom: 1;\n  *display: inline;\n}\n\n.CodeMirror-gutter-wrapper {\n  background: none !important;\n  border: none !important;\n  position: absolute;\n  z-index: 4;\n}\n\n.CodeMirror-gutter-background {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 4;\n}\n\n.CodeMirror-gutter-elt {\n  cursor: default;\n  position: absolute;\n  z-index: 4;\n}\n\n.CodeMirror-gutter-wrapper {\n  user-select: none;\n}\n\n.CodeMirror-lines {\n  cursor: text;\n  min-height: 1px; /* prevents collapsing before first draw */\n}\n\n.CodeMirror pre {\n  -webkit-tap-highlight-color: transparent;\n  /* Reset some styles that the rest of the page might have set */\n  background: transparent;\n  border-radius: 0;\n  border-width: 0;\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-variant-ligatures: none;\n  line-height: inherit;\n  margin: 0;\n  overflow: visible;\n  position: relative;\n  white-space: pre;\n  word-wrap: normal;\n  z-index: 2;\n}\n\n.CodeMirror-wrap pre {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  word-break: normal;\n}\n\n.CodeMirror-linebackground {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 0;\n}\n\n.CodeMirror-linewidget {\n  overflow: auto;\n  position: relative;\n  z-index: 2;\n}\n\n.CodeMirror-widget {\n}\n\n.CodeMirror-code {\n  outline: none;\n}\n\n/* Force content-box sizing for the elements where we expect it */\n\n.CodeMirror-scroll,\n.CodeMirror-sizer,\n.CodeMirror-gutter,\n.CodeMirror-gutters,\n.CodeMirror-linenumber {\n  box-sizing: content-box;\n}\n\n.CodeMirror-measure {\n  height: 0;\n  overflow: hidden;\n  position: absolute;\n  visibility: hidden;\n  width: 100%;\n}\n\n.CodeMirror-cursor {\n  position: absolute;\n}\n\n.CodeMirror-measure pre {\n  position: static;\n}\n\ndiv.CodeMirror-cursors {\n  position: relative;\n  visibility: hidden;\n  z-index: 3;\n}\n\ndiv.CodeMirror-dragcursors {\n  visibility: visible;\n}\n\n.CodeMirror-focused div.CodeMirror-cursors {\n  visibility: visible;\n}\n\n.CodeMirror-selected {\n  background: #d9d9d9;\n}\n\n.CodeMirror-focused .CodeMirror-selected {\n  background: #d7d4f0;\n}\n\n.CodeMirror-crosshair {\n  cursor: crosshair;\n}\n\n.CodeMirror-line::selection,\n.CodeMirror-line > span::selection,\n.CodeMirror-line > span > span::selection {\n  background: #d7d4f0;\n}\n\n.CodeMirror-line::-moz-selection,\n.CodeMirror-line > span::-moz-selection,\n.CodeMirror-line > span > span::-moz-selection {\n  background: #d7d4f0;\n}\n\n.cm-searching {\n  background: #ffa;\n  background: rgba(255, 255, 0, 0.4);\n}\n\n/* IE7 hack to prevent it from returning funny offsetTops on the spans */\n\n.CodeMirror span {\n  *vertical-align: text-bottom;\n}\n\n/* Used to force a border model for a node */\n\n.cm-force-border {\n  padding-right: 0.1px;\n}\n\n@media print {\n  /* Hide the cursor when printing */\n  .CodeMirror div.CodeMirror-cursors {\n    visibility: hidden;\n  }\n}\n\n/* See issue #2901 */\n\n.cm-tab-wrap-hack:after {\n  content: '';\n}\n\n/* Help users use markselection to safely style text background */\n\nspan.CodeMirror-selectedtext {\n  background: none;\n}\n\n.CodeMirror-dialog {\n  background: inherit;\n  color: inherit;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n  padding: 0.1em 0.8em;\n  position: absolute;\n  z-index: 15;\n}\n\n.CodeMirror-dialog-top {\n  border-bottom: 1px solid #eee;\n  top: 0;\n}\n\n.CodeMirror-dialog-bottom {\n  border-top: 1px solid #eee;\n  bottom: 0;\n}\n\n.CodeMirror-dialog input {\n  background: transparent;\n  border: 1px solid #d3d6db;\n  color: inherit;\n  font-family: monospace;\n  outline: none;\n  width: 20em;\n}\n\n.CodeMirror-dialog button {\n  font-size: 70%;\n}\n\n.CodeMirror-foldmarker {\n  color: blue;\n  cursor: pointer;\n  font-family: arial;\n  line-height: 0.3;\n  text-shadow: #b9f 1px 1px 2px, #b9f -1px -1px 2px, #b9f 1px -1px 2px,\n    #b9f -1px 1px 2px;\n}\n.CodeMirror-foldgutter {\n  width: 0.7em;\n}\n.CodeMirror-foldgutter-open,\n.CodeMirror-foldgutter-folded {\n  cursor: pointer;\n}\n.CodeMirror-foldgutter-open:after {\n  content: '\\25BE';\n}\n.CodeMirror-foldgutter-folded:after {\n  content: '\\25B8';\n}\n\n.CodeMirror-info {\n  background: white;\n  border-radius: 2px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);\n  box-sizing: border-box;\n  color: #555;\n  font-family: system, -apple-system, 'San Francisco', '.SFNSDisplay-Regular',\n    'Segoe UI', Segoe, 'Segoe WP', 'Helvetica Neue', helvetica, 'Lucida Grande',\n    arial, sans-serif;\n  font-size: 13px;\n  line-height: 16px;\n  margin: 8px -8px;\n  max-width: 400px;\n  opacity: 0;\n  overflow: hidden;\n  padding: 8px 8px;\n  position: fixed;\n  transition: opacity 0.15s;\n  z-index: 50;\n}\n\n.CodeMirror-info :first-child {\n  margin-top: 0;\n}\n\n.CodeMirror-info :last-child {\n  margin-bottom: 0;\n}\n\n.CodeMirror-info p {\n  margin: 1em 0;\n}\n\n.CodeMirror-info .info-description {\n  color: #777;\n  line-height: 16px;\n  margin-top: 1em;\n  max-height: 80px;\n  overflow: hidden;\n}\n\n.CodeMirror-info .info-deprecation {\n  background: #fffae8;\n  box-shadow: inset 0 1px 1px -1px #bfb063;\n  color: #867f70;\n  line-height: 16px;\n  margin: -8px;\n  margin-top: 8px;\n  max-height: 80px;\n  overflow: hidden;\n  padding: 8px;\n}\n\n.CodeMirror-info .info-deprecation-label {\n  color: #c79b2e;\n  cursor: default;\n  display: block;\n  font-size: 9px;\n  font-weight: bold;\n  letter-spacing: 1px;\n  line-height: 1;\n  padding-bottom: 5px;\n  text-transform: uppercase;\n  user-select: none;\n}\n\n.CodeMirror-info .info-deprecation-label + * {\n  margin-top: 0;\n}\n\n.CodeMirror-info a {\n  text-decoration: none;\n}\n\n.CodeMirror-info a:hover {\n  text-decoration: underline;\n}\n\n.CodeMirror-info .type-name {\n  color: #ca9800;\n}\n\n.CodeMirror-info .field-name {\n  color: #1f61a0;\n}\n\n.CodeMirror-info .enum-value {\n  color: #0b7fc7;\n}\n\n.CodeMirror-info .arg-name {\n  color: #8b2bb9;\n}\n\n.CodeMirror-info .directive-name {\n  color: #b33086;\n}\n\n.CodeMirror-jump-token {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* The lint marker gutter */\n.CodeMirror-lint-markers {\n  width: 16px;\n}\n.CodeMirror-lint-tooltip {\n  background-color: infobackground;\n  border-radius: 4px 4px 4px 4px;\n  border: 1px solid black;\n  color: infotext;\n  font-family: monospace;\n  font-size: 10pt;\n  max-width: 600px;\n  opacity: 0;\n  overflow: hidden;\n  padding: 2px 5px;\n  position: fixed;\n  transition: opacity 0.4s;\n  white-space: pre-wrap;\n  z-index: 100;\n}\n.CodeMirror-lint-mark-error,\n.CodeMirror-lint-mark-warning {\n  background-position: left bottom;\n  background-repeat: repeat-x;\n}\n.CodeMirror-lint-mark-error {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sJDw4cOCW1/KIAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAHElEQVQI12NggIL/DAz/GdA5/xkY/qPKMDAwAADLZwf5rvm+LQAAAABJRU5ErkJggg==');\n}\n.CodeMirror-lint-mark-warning {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sJFhQXEbhTg7YAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAMklEQVQI12NkgIIvJ3QXMjAwdDN+OaEbysDA4MPAwNDNwMCwiOHLCd1zX07o6kBVGQEAKBANtobskNMAAAAASUVORK5CYII=');\n}\n.CodeMirror-lint-marker-error,\n.CodeMirror-lint-marker-warning {\n  background-position: center center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  display: inline-block;\n  height: 16px;\n  position: relative;\n  vertical-align: middle;\n  width: 16px;\n}\n.CodeMirror-lint-message-error,\n.CodeMirror-lint-message-warning {\n  background-position: top left;\n  background-repeat: no-repeat;\n  padding-left: 18px;\n}\n.CodeMirror-lint-marker-error,\n.CodeMirror-lint-message-error {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAHlBMVEW7AAC7AACxAAC7AAC7AAAAAAC4AAC5AAD///+7AAAUdclpAAAABnRSTlMXnORSiwCK0ZKSAAAATUlEQVR42mWPOQ7AQAgDuQLx/z8csYRmPRIFIwRGnosRrpamvkKi0FTIiMASR3hhKW+hAN6/tIWhu9PDWiTGNEkTtIOucA5Oyr9ckPgAWm0GPBog6v4AAAAASUVORK5CYII=');\n}\n.CodeMirror-lint-marker-warning,\n.CodeMirror-lint-message-warning {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAANlBMVEX/uwDvrwD/uwD/uwD/uwD/uwD/uwD/uwD/uwD6twD/uwAAAADurwD2tQD7uAD+ugAAAAD/uwDhmeTRAAAADHRSTlMJ8mN1EYcbmiixgACm7WbuAAAAVklEQVR42n3PUQqAIBBFUU1LLc3u/jdbOJoW1P08DA9Gba8+YWJ6gNJoNYIBzAA2chBth5kLmG9YUoG0NHAUwFXwO9LuBQL1giCQb8gC9Oro2vp5rncCIY8L8uEx5ZkAAAAASUVORK5CYII=');\n}\n.CodeMirror-lint-marker-multiple {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAMAAADzjKfhAAAACVBMVEUAAAAAAAC/v7914kyHAAAAAXRSTlMAQObYZgAAACNJREFUeNo1ioEJAAAIwmz/H90iFFSGJgFMe3gaLZ0od+9/AQZ0ADosbYraAAAAAElFTkSuQmCC');\n  background-position: right bottom;\n  background-repeat: no-repeat;\n  width: 100%;\n  height: 100%;\n}\n\n.graphiql-container .spinner-container {\n  height: 36px;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 36px;\n  z-index: 10;\n}\n\n.graphiql-container .spinner {\n  animation: rotation 0.6s infinite linear;\n  border-bottom: 6px solid rgba(150, 150, 150, 0.15);\n  border-left: 6px solid rgba(150, 150, 150, 0.15);\n  border-radius: 100%;\n  border-right: 6px solid rgba(150, 150, 150, 0.15);\n  border-top: 6px solid rgba(150, 150, 150, 0.8);\n  display: inline-block;\n  height: 24px;\n  position: absolute;\n  vertical-align: middle;\n  width: 24px;\n}\n\n@keyframes rotation {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n}\n\n.CodeMirror-hints {\n  background: white;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);\n  font-family: 'Consolas', 'Inconsolata', 'Droid Sans Mono', 'Monaco', monospace;\n  font-size: 13px;\n  list-style: none;\n  margin-left: -6px;\n  margin: 0;\n  max-height: 14.5em;\n  overflow: hidden;\n  overflow-y: auto;\n  padding: 0;\n  position: absolute;\n  z-index: 10;\n}\n\n.CodeMirror-hint {\n  border-top: solid 1px #f7f7f7;\n  color: #141823;\n  cursor: pointer;\n  margin: 0;\n  max-width: 300px;\n  overflow: hidden;\n  padding: 2px 6px;\n  white-space: pre;\n}\n\nli.CodeMirror-hint-active {\n  background-color: #08f;\n  border-top-color: white;\n  color: white;\n}\n\n.CodeMirror-hint-information {\n  border-top: solid 1px #c0c0c0;\n  max-width: 300px;\n  padding: 4px 6px;\n  position: relative;\n  z-index: 1;\n}\n\n.CodeMirror-hint-information:first-child {\n  border-bottom: solid 1px #c0c0c0;\n  border-top: none;\n  margin-bottom: -1px;\n}\n\n.CodeMirror-hint-deprecation {\n  background: #fffae8;\n  box-shadow: inset 0 1px 1px -1px #bfb063;\n  color: #867f70;\n  font-family: system, -apple-system, 'San Francisco', '.SFNSDisplay-Regular',\n    'Segoe UI', Segoe, 'Segoe WP', 'Helvetica Neue', helvetica, 'Lucida Grande',\n    arial, sans-serif;\n  font-size: 13px;\n  line-height: 16px;\n  margin-top: 4px;\n  max-height: 80px;\n  overflow: hidden;\n  padding: 6px;\n}\n\n.CodeMirror-hint-deprecation .deprecation-label {\n  color: #c79b2e;\n  cursor: default;\n  display: block;\n  font-size: 9px;\n  font-weight: bold;\n  letter-spacing: 1px;\n  line-height: 1;\n  padding-bottom: 5px;\n  text-transform: uppercase;\n  user-select: none;\n}\n\n.CodeMirror-hint-deprecation .deprecation-label + * {\n  margin-top: 0;\n}\n\n.CodeMirror-hint-deprecation :last-child {\n  margin-bottom: 0;\n}\n\n.graphiql-container .doc-explorer {\n  background: white;\n}\n\n.graphiql-container .doc-explorer-title-bar,\n.graphiql-container .history-title-bar {\n  cursor: default;\n  display: flex;\n  align-items: center;\n  position: relative;\n  user-select: none;\n}\n.doc-explorer-title {\n  height: 34px;\n}\n.graphiql-container .doc-explorer-title,\n.graphiql-container .history-title {\n  flex: 1;\n  font-weight: bold;\n  padding: 10px 0 10px 10px;\n  text-align: center;\n  text-overflow: ellipsis;\n  user-select: text;\n  white-space: nowrap;\n}\n\n.graphiql-container .doc-explorer-back {\n  color: #3b5998;\n  cursor: pointer;\n  margin: -7px 0 -6px -8px;\n  overflow-x: hidden;\n  padding: 17px 12px 16px 16px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  background: 0;\n  border: 0;\n  line-height: 14px;\n}\n\n.doc-explorer-narrow .doc-explorer-back {\n  width: 0;\n}\n\n.graphiql-container .doc-explorer-back:before {\n  border-left: 2px solid #3b5998;\n  border-top: 2px solid #3b5998;\n  content: '';\n  display: inline-block;\n  height: 9px;\n  margin: 0 3px -1px 0;\n  position: relative;\n  transform: rotate(-45deg);\n  width: 9px;\n}\n\n.graphiql-container .doc-explorer-rhs {\n  position: relative;\n}\n\n.graphiql-container .doc-explorer-contents,\n.graphiql-container .history-contents {\n  background-color: #ffffff;\n  border-top: 1px solid #d6d6d6;\n  bottom: 0;\n  left: 0;\n  overflow-y: auto;\n  padding: 20px 15px;\n  position: absolute;\n  right: 0;\n  top: 47px;\n}\n\n.graphiql-container .doc-explorer-contents {\n  min-width: 300px;\n}\n\n.graphiql-container .doc-type-description p:first-child,\n.graphiql-container .doc-type-description blockquote:first-child {\n  margin-top: 0;\n}\n\n.graphiql-container .doc-explorer-contents a {\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.graphiql-container .doc-explorer-contents a:hover {\n  text-decoration: underline;\n}\n\n.graphiql-container .doc-value-description > :first-child {\n  margin-top: 4px;\n}\n\n.graphiql-container .doc-value-description > :last-child {\n  margin-bottom: 4px;\n}\n\n.graphiql-container .doc-type-description code,\n.graphiql-container .doc-type-description pre,\n.graphiql-container .doc-category code,\n.graphiql-container .doc-category pre {\n  --saf-0: rgba(var(--sk_foreground_low, 29, 28, 29), 0.13);\n  font-size: 12px;\n  line-height: 1.50001;\n  font-variant-ligatures: none;\n  white-space: pre;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  word-break: normal;\n  tab-size: 4;\n}\n\n.graphiql-container .doc-type-description code,\n.graphiql-container .doc-category code {\n  padding: 2px 3px 1px;\n  border: 1px solid var(--saf-0);\n  border-radius: 3px;\n  background-color: rgba(var(--sk_foreground_min, 29, 28, 29), 0.04);\n  color: #e01e5a;\n  background-color: white;\n}\n\n.graphiql-container .doc-category {\n  margin: 20px 0;\n}\n\n.graphiql-container .doc-category-title {\n  border-bottom: 1px solid #e0e0e0;\n  color: #777;\n  cursor: default;\n  font-size: 14px;\n  font-variant: small-caps;\n  font-weight: bold;\n  letter-spacing: 1px;\n  margin: 0 -15px 10px 0;\n  padding: 10px 0;\n  user-select: none;\n}\n\n.graphiql-container .doc-category-item {\n  margin: 12px 0;\n  color: #555;\n}\n\n.graphiql-container .keyword {\n  color: #b11a04;\n}\n\n.graphiql-container .type-name {\n  color: #ca9800;\n}\n\n.graphiql-container .field-name {\n  color: #1f61a0;\n}\n\n.graphiql-container .field-short-description {\n  color: #999;\n  margin-left: 5px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.graphiql-container .enum-value {\n  color: #0b7fc7;\n}\n\n.graphiql-container .arg-name {\n  color: #8b2bb9;\n}\n\n.graphiql-container .arg {\n  display: block;\n  margin-left: 1em;\n}\n\n.graphiql-container .arg:first-child:last-child,\n.graphiql-container .arg:first-child:nth-last-child(2),\n.graphiql-container .arg:first-child:nth-last-child(2) ~ .arg {\n  display: inherit;\n  margin: inherit;\n}\n\n.graphiql-container .arg:first-child:nth-last-child(2):after {\n  content: ', ';\n}\n\n.graphiql-container .arg-default-value {\n  color: #43a047;\n}\n\n.graphiql-container .doc-deprecation {\n  background: #fffae8;\n  box-shadow: inset 0 0 1px #bfb063;\n  color: #867f70;\n  line-height: 16px;\n  margin: 8px -8px;\n  max-height: 80px;\n  overflow: hidden;\n  padding: 8px;\n  border-radius: 3px;\n}\n\n.graphiql-container .doc-deprecation:before {\n  content: 'Deprecated:';\n  color: #c79b2e;\n  cursor: default;\n  display: block;\n  font-size: 9px;\n  font-weight: bold;\n  letter-spacing: 1px;\n  line-height: 1;\n  padding-bottom: 5px;\n  text-transform: uppercase;\n  user-select: none;\n}\n\n.graphiql-container .doc-deprecation > :first-child {\n  margin-top: 0;\n}\n\n.graphiql-container .doc-deprecation > :last-child {\n  margin-bottom: 0;\n}\n\n.graphiql-container .show-btn {\n  -webkit-appearance: initial;\n  display: block;\n  border-radius: 3px;\n  border: solid 1px #ccc;\n  text-align: center;\n  padding: 8px 12px 10px;\n  width: 100%;\n  box-sizing: border-box;\n  background: #fbfcfc;\n  color: #555;\n  cursor: pointer;\n}\n\n.graphiql-container .search-box {\n  border-bottom: 1px solid #d3d6db;\n  display: block;\n  font-size: 14px;\n  margin: -15px -15px 12px 0;\n  position: relative;\n  font-weight: 400;\n}\n\n.graphiql-container .search-box:before {\n  color: dimgray;\n  content: '\\26b2';\n  cursor: pointer;\n  display: block;\n  font-size: 24px;\n  left: 8px;\n  position: absolute;\n  top: -2px;\n  transform: rotate(-45deg);\n  user-select: none;\n}\n\n.graphiql-container .search-box .search-box-clear {\n  background-color: #d0d0d0;\n  border-radius: 12px;\n  border: 0;\n  color: #fff;\n  cursor: pointer;\n  font-size: 11px;\n  padding: 1px 5px;\n  position: absolute;\n  right: 6px;\n  top: 7px;\n  user-select: none;\n}\n\n.graphiql-container .search-box .search-box-clear:hover {\n  background-color: #b9b9b9;\n}\n\n.graphiql-container .search-box > input {\n  border: none;\n  box-sizing: border-box;\n  font-size: 14px;\n  outline: none;\n  padding: 6px 24px 8px 28px;\n  width: 100%;\n}\n\n.graphiql-container .search-box .search-box-icon {\n  display: none;\n}\n\n.graphiql-container .error-container {\n  font-weight: bold;\n  left: 0;\n  letter-spacing: 1px;\n  opacity: 0.5;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  text-transform: uppercase;\n  top: 50%;\n  transform: translate(0, -50%);\n}\n.CodeMirror-foldmarker {\n  color: blue;\n  cursor: pointer;\n  font-family: arial;\n  line-height: 0.3;\n  text-shadow: #b9f 1px 1px 2px, #b9f -1px -1px 2px, #b9f 1px -1px 2px,\n    #b9f -1px 1px 2px;\n}\n.CodeMirror-foldgutter {\n  width: 0.7em;\n}\n.CodeMirror-foldgutter-open,\n.CodeMirror-foldgutter-folded {\n  cursor: pointer;\n}\n.CodeMirror-foldgutter-open:after {\n  content: '\\25BE';\n}\n.CodeMirror-foldgutter-folded:after {\n  content: '\\25B8';\n}\n.graphiql-container .history-contents,\n.graphiql-container .history-contents input {\n  font-family: 'Consolas', 'Inconsolata', 'Droid Sans Mono', 'Monaco', monospace;\n}\n\n.graphiql-container .history-contents {\n  margin: 0;\n  padding: 0;\n}\n\n.graphiql-container .history-contents li {\n  align-items: center;\n  display: flex;\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin: 0;\n  padding: 8px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.graphiql-container .history-contents li button:not(.history-label) {\n  display: none;\n  margin-left: 10px;\n}\n\n.graphiql-container .history-contents li:hover button:not(.history-label),\n.graphiql-container\n  .history-contents\n  li:focus-within\n  button:not(.history-label) {\n  display: inline-block;\n}\n\n.graphiql-container .history-contents input,\n.graphiql-container .history-contents button {\n  padding: 0;\n  background: 0;\n  border: 0;\n  font-size: inherit;\n  font-family: inherit;\n  line-height: 14px;\n  color: inherit;\n}\n\n.graphiql-container .history-contents input {\n  flex-grow: 1;\n}\n\n.graphiql-container .history-contents input::placeholder {\n  color: inherit;\n}\n\n.graphiql-container .history-contents button {\n  cursor: pointer;\n  text-align: left;\n}\n\n.graphiql-container .history-contents .history-label {\n  flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.CodeMirror-info {\n  background: white;\n  border-radius: 2px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);\n  box-sizing: border-box;\n  color: #555;\n  font-family: system, -apple-system, 'San Francisco', '.SFNSDisplay-Regular',\n    'Segoe UI', Segoe, 'Segoe WP', 'Helvetica Neue', helvetica, 'Lucida Grande',\n    arial, sans-serif;\n  font-size: 13px;\n  line-height: 16px;\n  margin: 8px -8px;\n  max-width: 400px;\n  opacity: 0;\n  overflow: hidden;\n  padding: 8px 8px;\n  position: fixed;\n  transition: opacity 0.15s;\n  z-index: 50;\n}\n\n.CodeMirror-info :first-child {\n  margin-top: 0;\n}\n\n.CodeMirror-info :last-child {\n  margin-bottom: 0;\n}\n\n.CodeMirror-info p {\n  margin: 1em 0;\n}\n\n.CodeMirror-info .info-description {\n  color: #777;\n  line-height: 16px;\n  margin-top: 1em;\n  max-height: 80px;\n  overflow: hidden;\n}\n\n.CodeMirror-info .info-deprecation {\n  background: #fffae8;\n  box-shadow: inset 0 1px 1px -1px #bfb063;\n  color: #867f70;\n  line-height: 16px;\n  margin: -8px;\n  margin-top: 8px;\n  max-height: 80px;\n  overflow: hidden;\n  padding: 8px;\n}\n\n.CodeMirror-info .info-deprecation-label {\n  color: #c79b2e;\n  cursor: default;\n  display: block;\n  font-size: 9px;\n  font-weight: bold;\n  letter-spacing: 1px;\n  line-height: 1;\n  padding-bottom: 5px;\n  text-transform: uppercase;\n  user-select: none;\n}\n\n.CodeMirror-info .info-deprecation-label + * {\n  margin-top: 0;\n}\n\n.CodeMirror-info a {\n  text-decoration: none;\n}\n\n.CodeMirror-info a:hover {\n  text-decoration: underline;\n}\n\n.CodeMirror-info .type-name {\n  color: #ca9800;\n}\n\n.CodeMirror-info .field-name {\n  color: #1f61a0;\n}\n\n.CodeMirror-info .enum-value {\n  color: #0b7fc7;\n}\n\n.CodeMirror-info .arg-name {\n  color: #8b2bb9;\n}\n\n.CodeMirror-info .directive-name {\n  color: #b33086;\n}\n.CodeMirror-jump-token {\n  text-decoration: underline;\n  cursor: pointer;\n}\n/* The lint marker gutter */\n.CodeMirror-lint-markers {\n  width: 16px;\n}\n\n.CodeMirror-lint-tooltip {\n  background-color: infobackground;\n  border-radius: 4px 4px 4px 4px;\n  border: 1px solid black;\n  color: infotext;\n  font-family: monospace;\n  font-size: 10pt;\n  max-width: 600px;\n  opacity: 0;\n  overflow: hidden;\n  padding: 2px 5px;\n  position: fixed;\n  transition: opacity 0.4s;\n  white-space: pre-wrap;\n  z-index: 100;\n}\n\n.CodeMirror-lint-mark-error,\n.CodeMirror-lint-mark-warning {\n  background-position: left bottom;\n  background-repeat: repeat-x;\n}\n\n.CodeMirror-lint-mark-error {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sJDw4cOCW1/KIAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAHElEQVQI12NggIL/DAz/GdA5/xkY/qPKMDAwAADLZwf5rvm+LQAAAABJRU5ErkJggg==');\n}\n\n.CodeMirror-lint-mark-warning {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sJFhQXEbhTg7YAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAMklEQVQI12NkgIIvJ3QXMjAwdDN+OaEbysDA4MPAwNDNwMCwiOHLCd1zX07o6kBVGQEAKBANtobskNMAAAAASUVORK5CYII=');\n}\n\n.CodeMirror-lint-marker-error,\n.CodeMirror-lint-marker-warning {\n  background-position: center center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  display: inline-block;\n  height: 16px;\n  position: relative;\n  vertical-align: middle;\n  width: 16px;\n}\n\n.CodeMirror-lint-message-error,\n.CodeMirror-lint-message-warning {\n  background-position: top left;\n  background-repeat: no-repeat;\n  padding-left: 18px;\n}\n\n.CodeMirror-lint-marker-error,\n.CodeMirror-lint-message-error {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAHlBMVEW7AAC7AACxAAC7AAC7AAAAAAC4AAC5AAD///+7AAAUdclpAAAABnRSTlMXnORSiwCK0ZKSAAAATUlEQVR42mWPOQ7AQAgDuQLx/z8csYRmPRIFIwRGnosRrpamvkKi0FTIiMASR3hhKW+hAN6/tIWhu9PDWiTGNEkTtIOucA5Oyr9ckPgAWm0GPBog6v4AAAAASUVORK5CYII=');\n}\n\n.CodeMirror-lint-marker-warning,\n.CodeMirror-lint-message-warning {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAANlBMVEX/uwDvrwD/uwD/uwD/uwD/uwD/uwD/uwD/uwD6twD/uwAAAADurwD2tQD7uAD+ugAAAAD/uwDhmeTRAAAADHRSTlMJ8mN1EYcbmiixgACm7WbuAAAAVklEQVR42n3PUQqAIBBFUU1LLc3u/jdbOJoW1P08DA9Gba8+YWJ6gNJoNYIBzAA2chBth5kLmG9YUoG0NHAUwFXwO9LuBQL1giCQb8gC9Oro2vp5rncCIY8L8uEx5ZkAAAAASUVORK5CYII=');\n}\n\n.CodeMirror-lint-marker-multiple {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAMAAADzjKfhAAAACVBMVEUAAAAAAAC/v7914kyHAAAAAXRSTlMAQObYZgAAACNJREFUeNo1ioEJAAAIwmz/H90iFFSGJgFMe3gaLZ0od+9/AQZ0ADosbYraAAAAAElFTkSuQmCC');\n  background-position: right bottom;\n  background-repeat: no-repeat;\n  width: 100%;\n  height: 100%;\n}\n.graphiql-container .spinner-container {\n  height: 36px;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 36px;\n  z-index: 10;\n}\n\n.graphiql-container .spinner {\n  animation: rotation 0.6s infinite linear;\n  border-bottom: 6px solid rgba(150, 150, 150, 0.15);\n  border-left: 6px solid rgba(150, 150, 150, 0.15);\n  border-radius: 100%;\n  border-right: 6px solid rgba(150, 150, 150, 0.15);\n  border-top: 6px solid rgba(150, 150, 150, 0.8);\n  display: inline-block;\n  height: 24px;\n  position: absolute;\n  vertical-align: middle;\n  width: 24px;\n}\n\n@keyframes rotation {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n}\n.CodeMirror-hints {\n  background: white;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);\n  font-family: 'Consolas', 'Inconsolata', 'Droid Sans Mono', 'Monaco', monospace;\n  font-size: 13px;\n  list-style: none;\n  margin-left: -6px;\n  margin: 0;\n  max-height: 14.5em;\n  overflow-y: auto;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  z-index: 10;\n}\n\n.CodeMirror-hint {\n  border-top: solid 1px #f7f7f7;\n  color: #141823;\n  cursor: pointer;\n  margin: 0;\n  max-width: 300px;\n  overflow: hidden;\n  padding: 2px 6px;\n  white-space: pre;\n}\n\nli.CodeMirror-hint-active {\n  background-color: #08f;\n  border-top-color: white;\n  color: white;\n}\n\n.CodeMirror-hint-information {\n  border-top: solid 1px #c0c0c0;\n  max-width: 300px;\n  padding: 4px 6px;\n  position: relative;\n  z-index: 1;\n}\n\n.CodeMirror-hint-information:first-child {\n  border-bottom: solid 1px #c0c0c0;\n  border-top: none;\n  margin-bottom: -1px;\n}\n\n.CodeMirror-hint-deprecation {\n  background: #fffae8;\n  box-shadow: inset 0 1px 1px -1px #bfb063;\n  color: #867f70;\n  font-family: system, -apple-system, 'San Francisco', '.SFNSDisplay-Regular',\n    'Segoe UI', Segoe, 'Segoe WP', 'Helvetica Neue', helvetica, 'Lucida Grande',\n    arial, sans-serif;\n  font-size: 13px;\n  line-height: 16px;\n  margin-top: 4px;\n  max-height: 80px;\n  overflow: hidden;\n  padding: 6px;\n}\n\n.CodeMirror-hint-deprecation .deprecation-label {\n  color: #c79b2e;\n  cursor: default;\n  display: block;\n  font-size: 9px;\n  font-weight: bold;\n  letter-spacing: 1px;\n  line-height: 1;\n  padding-bottom: 5px;\n  text-transform: uppercase;\n  user-select: none;\n}\n\n.CodeMirror-hint-deprecation .deprecation-label + * {\n  margin-top: 0;\n}\n\n.CodeMirror-hint-deprecation :last-child {\n  margin-bottom: 0;\n}\n\n.graphiql_footer {\n  display: flex;\n  align-items: center;\n  position: sticky;\n  bottom: 0;\n  width: 100%;\n  padding: 8px;\n  background: #eee;\n  z-index: 100;\n}\n\n.graphiql_footer_label {\n  font-size: 10px;\n  color: #777777;\n  font-weight: 600;\n  margin-right: 8px;\n  text-transform: uppercase;\n}\n\n.graphiql_footer_value {\n  margin-right: 16px;\n  font-size: 13px;\n}\n\n.graphiql_footer_icon {\n  color: #777;\n  margin-right: 8px;\n  margin-left: 0px;\n}\n\n.color_green {\n  color: #047857 !important;\n}\n\n.graphiql-explorer-node > span > svg {\n  margin-left: 0px !important;\n}\n\n.graphiql-code-exporter .CodeMirror {\n  position: relative;\n  font-size: 11px;\n  background: transparent;\n}\n.graphiql-code-exporter .CodeMirror-lines {\n  padding-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
